var xr = Object.defineProperty;
var vr = (n, t, e) => t in n ? xr(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var P = (n, t, e) => vr(n, typeof t != "symbol" ? t + "" : t, e);
import { jsx as i, jsxs as D, Fragment as ee } from "react/jsx-runtime";
import * as ke from "react";
import Cr, { createContext as St, useContext as Ot, Component as Tr, isValidElement as kr, forwardRef as ye, useState as R, useRef as H, useImperativeHandle as Pr, useCallback as N, useMemo as se, useEffect as G, useLayoutEffect as Bt, Fragment as Et, memo as Fe } from "react";
import { Trans as un, useTranslation as ce } from "react-i18next";
import { Stack as mt, Text as Z, TonicProvider as Dr, Modal as Mr, ModalOverlay as Sr, ModalContent as Or, ModalCloseButton as Er, useModal as Ir, ModalFooter as gt, Button as ne, ModalHeader as Rr, ModalBody as Nr, Flex as q, Icon as Ne, Spinner as pt, Space as Ie, SearchInput as hn, ButtonBase as fn, Divider as wt, Menu as be, MenuButton as nt, MenuList as xe, MenuItem as oe, Input as Ar, ButtonGroup as Fr, Grid as yt, Box as W, Tooltip as mn, useColorMode as Pe, Table as gn, TableScrollbar as _r, TableHeader as pn, TableRow as Xe, TableCell as Ke, TableBody as wn, Collapse as It, Checkbox as He, useColorStyle as rt, Truncate as Lr, useTheme as Wr, MenuToggle as Be, Tag as Yr, MenuGroup as Hr, CheckboxGroup as yn, LinkButton as Rt, Scrollbar as bn, TextLabel as lt, OverflowTooltip as Nt, DatePicker as zr, InputControl as xn, InputAdornment as vn, Alert as Br, Drawer as qr, DrawerOverlay as $r, DrawerContent as Gr, DrawerHeader as Vr, DrawerBody as jr, DrawerCloseButton as Qr, useDrawer as Ur, DrawerFooter as qt, TabList as Xr, Portal as Kr } from "@tonic-ui/react";
import bt, { t as Se } from "i18next";
import { useReactTable as Jr, getSortedRowModel as Zr, getFilteredRowModel as eo, getExpandedRowModel as to, getCoreRowModel as no, flexRender as je } from "@tanstack/react-table";
import { useInView as ro } from "react-intersection-observer";
import { SortUpIcon as Cn, SortDownIcon as Tn, AngleRightIcon as At, AngleLeftIcon as oo, ChevronDownIcon as ao, ChevronRightIcon as io, CalendarIcon as so, ClockIcon as co, ChevronLeftIcon as lo, FilterDeleteIcon as uo, FilterAddIcon as ho, SettingsIcon as fo } from "@tonic-ui/react-icons";
import { withEmotionCache as mo, ThemeContext as go, Global as po, css as wo } from "@emotion/react";
import { useMergeRefs as yo, useToggle as kn, useEventListener as Je, useEffectOnce as ot, useEffectOnceWhen as Pn, useConst as $t } from "@tonic-ui/react-hooks";
import { useQueryClient as bo, useInfiniteQuery as xo } from "@tanstack/react-query";
const Ue = (() => {
  var n, t, e, r;
  try {
    if (((n = window.top) == null ? void 0 : n.location.hostname) === "localhost") return "development";
    if (((t = window.top) == null ? void 0 : t.location.hostname) === "portal-int.visionone.trendmicro.com") return "alpha";
    if (((e = window.top) == null ? void 0 : e.location.hostname) === "portal-xdr.visionone.trendmicro.com") return "staging";
    if (((r = window.top) == null ? void 0 : r.location.hostname.match(/portal(\..+)?\.xdr\.trendmicro\.com/)) !== null)
      return "production";
  } catch {
  }
  return "";
})(), vo = (() => {
  try {
    return localStorage.getItem("uic_companyGUID") || "";
  } catch {
  }
  return "";
})(), Oc = {
  // Ring 0 Regions.PROD_AU, Regions.PROD_SG
  PROD_AU: "portal.au.xdr.trendmicro.com",
  PROD_SG: "portal.sg.xdr.trendmicro.com",
  // Ring 1  Regions.PROD_US, Regions.PROD_IN, Regions.PROD_MEA
  PROD_US: "portal.xdr.trendmicro.com",
  PROD_IN: "portal.in.xdr.trendmicro.com",
  PROD_MEA: "portal.mea.xdr.trendmicro.com",
  // Ring 2 Regions.PROD_JP, Regions.PROD_EU
  PROD_JP: "portal.jp.xdr.trendmicro.com",
  PROD_EU: "portal.eu.xdr.trendmicro.com"
  // Unknown if we use fedramp
  // PROD_FEDRAMP: 'portal.usgov.xdr.trendmicro.com',
}, Ec = {
  viewOpenCase: (n) => {
    var t;
    console.debug("CaseLogApi.view", n), (t = window.top) == null || t.CaseLogApi.view(n);
  },
  viewCaseList: (n) => {
    var t, e;
    console.debug("CaseLogApi.showList", { search: n.join(",") }), (e = (t = window.top) == null ? void 0 : t.CaseLogApi) == null || e.showList({ search: n.join(",") });
  },
  createNewCase: (n, t) => {
    var e;
    console.debug("CaseLogApi.create", n), (e = window.top) == null || e.CaseLogApi.create(n, t);
  },
  addAssetToComplianceCase: (n, t) => {
    var e;
    console.debug("CaseLogApi.addAssetToComplianceCase", n), (e = window.top) == null || e.CaseLogApi.addAssetToComplianceCase(n, t);
  }
}, Ic = (n, t) => {
  try {
    const e = {}, r = (() => {
      var s;
      try {
        const l = ((s = window.top) == null ? void 0 : s.location.hash.split("?")) ?? [], c = l.length > 1 ? new URLSearchParams(l[1]) : void 0;
        return c && c.has("feature-flags") ? JSON.parse(c.get("feature-flags") || "{}") : {};
      } catch {
        return {};
      }
    })(), o = { ...Co(n), ...r }, a = ko(t);
    return Object.entries(a).forEach(([s, l]) => {
      e[s] = To(l, o == null ? void 0 : o[s]);
    }), e;
  } catch {
    return console.warn(`Unexpected local storage value for: ${n}`), {};
  }
}, Co = (n) => {
  const t = JSON.parse(localStorage.getItem(n) || "{}");
  if (typeof t != "object" || !t)
    throw new Error(
      "Invalid structure in CMP_featureFlags. Needs to be a JSON object where each property is a flag name and its boolean value."
    );
  return t;
}, To = (n, t) => typeof t == "string" ? t === "true" : typeof t == "number" ? t === 1 : typeof t == "boolean" ? t : !t && (n.includes(Ue) || n.includes(vo)) ? !0 : !!t, ko = (n) => Object.entries(n).reduce(
  (t, [e, r]) => ({
    ...t,
    [e]: [
      ...new Set(
        r.map(
          (o) => {
            var a;
            return (
              // Replace regional prod URLs with 'production' so they get enabled when checking for ENV
              o === (((a = window.top) == null ? void 0 : a.location.hostname) || "") ? "production" : o
            );
          }
        )
      )
    ]
  }),
  {}
), Dn = St(void 0), Rc = () => Ot(Dn);
class Mn extends Tr {
  constructor(e) {
    super(e);
    P(this, "displayName", "ErrorBoundary");
    this.state = { hasError: !1, error: new Error() };
  }
  static getDerivedStateFromError(e) {
    return { hasError: !0, error: e };
  }
  componentDidCatch(e, r) {
    console.error(e, r);
  }
  render() {
    if (this.state.hasError) {
      const e = this.props.ErrorComponent;
      return /* @__PURE__ */ i(e, { error: this.state.error });
    }
    return this.props.children;
  }
}
const Po = (n) => n == null ? !1 : typeof n == "object" && ("children" in n || "props" in n && "children" in n.props), Do = (n) => {
  if (n != null) {
    if (typeof n == "object" && "children" in n)
      return n.children;
    if (typeof n == "object" && "props" in n && "children" in n.props)
      return n.props.children;
  }
}, Sn = (n, t) => t ? (Array.isArray(t) || (t = [t]), t.forEach((e, r) => {
  const o = `${r}`;
  if (typeof e == "string")
    n = `${n}${e}`;
  else if (Po(e)) {
    const a = Do(e);
    a && (n = Sn(n, a));
  } else kr(e) && (n = `${n}<${e.type}${o}/>`);
}), n) : "", On = bt.language === "ja" ? "、" : ", ", Re = ({ children: n, ...t }) => {
  typeof n == "function" && (n = n(t));
  let e = Sn("", n);
  return bt.exists(e) || (e = void 0), /* @__PURE__ */ i(un, { i18n: bt, i18nKey: e, ...t, children: n });
};
Re.displayName = "I18n";
const Mo = /* @__PURE__ */ D("svg", { xmlns: "http://www.w3.org/2000/svg", width: "144", height: "144", fill: "none", children: [
  /* @__PURE__ */ D("g", { clipPath: "url(#a)", children: [
    /* @__PURE__ */ D("g", { opacity: ".3", children: [
      /* @__PURE__ */ i(
        "path",
        {
          fill: "#8A8A8A",
          d: "M10 23.667A2.667 2.667 0 0 1 12.667 21h104.666A2.667 2.667 0 0 1 120 23.667V31H10z"
        }
      ),
      /* @__PURE__ */ i(
        "path",
        {
          fill: "#5E5E5E",
          d: "M105.5 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M10 31h110v75.333a2.667 2.667 0 0 1-2.667 2.667H12.667A2.667 2.667 0 0 1 10 106.333z"
        }
      )
    ] }),
    /* @__PURE__ */ i(
      "path",
      {
        fill: "#8A8A8A",
        d: "M24 37.667A2.667 2.667 0 0 1 26.667 35h104.666A2.667 2.667 0 0 1 134 37.667V45H24z"
      }
    ),
    /* @__PURE__ */ i(
      "path",
      {
        fill: "#5E5E5E",
        d: "M119.5 42a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M24 45h110v75.333a2.667 2.667 0 0 1-2.667 2.667H26.667A2.667 2.667 0 0 1 24 120.333z"
      }
    ),
    /* @__PURE__ */ i("path", { fill: "#424242", d: "M48 57h62v4H48zm0 10h62v4H48z" }),
    /* @__PURE__ */ i("path", { fill: "#151515", d: "m103 117.143 14.142-14.142 14.142 14.142-14.142 14.142z" }),
    /* @__PURE__ */ i(
      "path",
      {
        fill: "#FABA2A",
        d: "M136.276 115.224q.724.723.724 1.714 0 .99-.724 1.713l-17.062 17.063q-.724.724-1.714.724t-1.714-.724l-17.062-17.063q-.724-.723-.724-1.713t.724-1.714l17.062-17.063q.724-.724 1.714-.724t1.714.724zm-16.338 11.464v-4.876h-4.876v4.876zm0-7.313v-12.187h-4.876v12.187z"
      }
    )
  ] }),
  /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "a", children: /* @__PURE__ */ i("path", { fill: "#fff", d: "M0 0h144v144H0z" }) }) })
] }), So = {
  400: Se("400 Bad Request"),
  401: Se("401 Unauthorized"),
  403: Se("403 Forbidden"),
  404: Se("404 Not Found"),
  500: Se("500 Internal Server Error"),
  503: Se("503 Service Unavailable")
}, at = (n) => {
  const { error: t, variant: e } = n, r = t;
  return e === "card-error" ? /* @__PURE__ */ i(mt, { spacing: "2px", alignItems: "center", justifyContent: "center", paddingBottom: "4x", flex: "1", children: /* @__PURE__ */ i(Z, { textAlign: "center", size: "sm", color: "white:secondary", paddingBottom: "4x", children: /* @__PURE__ */ i(Re, { children: "A temporary issue occurred. Support engineers are working to resolve the issue. Try again later." }) }) }) : /* @__PURE__ */ i(Dr, { useCSSBaseline: !0, colorMode: { defaultValue: "dark" }, children: /* @__PURE__ */ i(
    mt,
    {
      height: "100%",
      alignItems: "center",
      justifyContent: "center",
      spacing: "2x",
      paddingX: "8x",
      flex: "1",
      children: /* @__PURE__ */ D(ee, { children: [
        Mo,
        /* @__PURE__ */ i(Z, { textAlign: "center", size: "lg", color: "white:primary", children: /* @__PURE__ */ i(Re, { children: "Temporary issue" }) }),
        /* @__PURE__ */ i(Z, { textAlign: "center", size: "sm", color: "white:secondary", children: /* @__PURE__ */ i(Re, { children: "A temporary issue occurred. Support engineers are working to resolve the issue. Try again later." }) }),
        /* @__PURE__ */ i(Z, { textAlign: "center", size: "sm", color: "white:secondary", children: So[r.status] })
      ] })
    }
  ) });
};
at.displayName = "GeneralErrorOverlay";
const Nc = ({
  children: n,
  isClosable: t = !0
}) => {
  const { onClose: e } = Ir(), { t: r } = ce();
  return n ? /* @__PURE__ */ i(gt, { children: n }) : t ? /* @__PURE__ */ i(gt, { children: /* @__PURE__ */ i(
    ne,
    {
      "data-testid": "modal-footer-close-button",
      onClick: e,
      children: r("Close")
    }
  ) }) : null;
}, En = (n) => {
  const {
    "data-id": t,
    data: e,
    children: r,
    initialFocusRef: o,
    isOpen: a = !1,
    minHeight: s,
    height: l,
    maxHeight: c,
    backdrop: d = !0,
    isClosable: u = !0,
    size: h = "md",
    ContentComponent: m,
    width: f,
    ...g
  } = n, w = typeof h == "number" || f ? "auto" : h;
  return /* @__PURE__ */ D(
    Mr,
    {
      "data-testid": `${t}-modal`,
      autoFocus: !0,
      isClosable: !1,
      closeOnEsc: !0,
      closeOnOutsideClick: !0,
      ensureFocus: !0,
      initialFocusRef: o,
      isOpen: a,
      size: w,
      ...g,
      children: [
        d && /* @__PURE__ */ i(Sr, {}),
        /* @__PURE__ */ D(
          Or,
          {
            ...s !== void 0 && { minHeight: s },
            ...l !== void 0 && { height: l },
            ...c !== void 0 && { maxHeight: c },
            ...(typeof h == "number" || f) && { width: f || h },
            children: [
              n.isOpen && /* @__PURE__ */ i(Mn, { ErrorComponent: at, children: m ? /* @__PURE__ */ i(m, { ...e }) : r }),
              u && /* @__PURE__ */ i(Er, { "data-track": "modal-close-button", "data-track-content": t })
            ]
          }
        )
      ]
    }
  );
};
En.displayName = "TonicModalWrapper";
let Oo = 1;
const dt = /* @__PURE__ */ new WeakMap(), Ac = (n) => {
  if (dt.has(n))
    return dt.get(n);
  {
    const t = String(Oo++);
    return dt.set(n, t), t;
  }
}, Eo = (n, t) => !n || !t || (n == null ? void 0 : n.length) !== (t == null ? void 0 : t.length) ? !1 : n.every((e, r) => e === t[r]), Io = (n) => new Promise((t) => setTimeout(t, n)), Ro = () => {
  const n = {};
  return n.promise = new Promise((t, e) => {
    n.resolve = t, n.reject = e;
  }), n;
}, In = ye((n, t) => {
  const { t: e } = ce(), [r, o] = R(!1), [a, s] = R(!1), [l, c] = R(!1), [d, u] = R(""), [h, m] = R(""), f = H(), g = H(), w = H();
  Pr(t, () => ({
    openModal: (y) => {
      var b;
      o(!0), u(y.message), m(y.submitMessage), c(!1), s(!1), g.current = y.onClose, f.current = y.onSubmit, (b = w.current) == null || b.reject();
      const p = Ro();
      return w.current = p, p.promise;
    }
  }));
  const x = N((y) => {
    var p, b;
    o(!1), (p = g.current) == null || p.call(g), (b = w.current) == null || b.resolve(y || { status: "closed" });
  }, []), v = N(() => x(), [x]), T = N(async () => {
    var p, b;
    const y = Io(600);
    try {
      f.current && (s(!0), await f.current(), await y), (p = w.current) == null || p.resolve({ status: "success" }), x({ status: "success" });
    } catch {
      c(!0), await y, (b = w.current) == null || b.reject({ status: "error" });
    } finally {
      s(!1);
    }
  }, [x]);
  return /* @__PURE__ */ D(En, { "data-id": "confirm-choice", size: "sm", isOpen: r, onClose: v, children: [
    /* @__PURE__ */ i(Rr, {}),
    /* @__PURE__ */ D(Nr, { children: [
      /* @__PURE__ */ D(q, { gap: "4x", children: [
        /* @__PURE__ */ i(Ne, { width: "48px", height: "48px", children: /* @__PURE__ */ i("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 48 48", children: /* @__PURE__ */ i(
          "path",
          {
            fill: "#FABA2A",
            d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24 24-10.7 24-24C48 10.8 37.3 0 24.1 0zm0 46C11.8 46 2 36.2 2 24S11.8 2 24 2s22 9.8 22 22c0 12.1-9.8 22-21.9 22zm-2-34h4v16h-4zm0 20h4v4h-4z"
          }
        ) }) }),
        d
      ] }),
      l && /* @__PURE__ */ i(q, { paddingY: "4x", children: /* @__PURE__ */ i(at, { variant: "card-error" }) })
    ] }),
    /* @__PURE__ */ i(gt, { alignItems: "end", children: /* @__PURE__ */ D(q, { children: [
      /* @__PURE__ */ D(
        ne,
        {
          variant: "primary",
          minWidth: "20x",
          onClick: T,
          ...a && { pointerEvents: "none" },
          children: [
            h,
            " ",
            a && /* @__PURE__ */ i(pt, { size: "xs", marginLeft: "2x" })
          ]
        }
      ),
      /* @__PURE__ */ i(Ie, { width: "2x" }),
      /* @__PURE__ */ i(ne, { minWidth: "20x", onClick: v, children: e("Cancel") })
    ] }) })
  ] });
});
In.displayName = "ConfirmModal";
const No = (n) => {
  const { children: t } = n, e = H(null), r = N((o) => e.current.openModal(o), []);
  return /* @__PURE__ */ D(Dn.Provider, { value: se(() => ({ openConfirmModal: r }), [r]), children: [
    /* @__PURE__ */ i(In, { ref: e }),
    t
  ] });
};
No.displayName = "ModalsProvider";
const Rn = (n) => {
  const { setGlobalFilter: t, SearchComponent: e = hn } = n, [r, o] = R("");
  return G(() => {
    const a = setTimeout(() => {
      t(r);
    }, 500);
    return () => {
      clearTimeout(a);
    };
  }, [r, t]), /* @__PURE__ */ i(
    e,
    {
      value: r,
      onChange: (a) => o(a.target.value.trim()),
      onClearInput: () => {
        o(""), t("");
      }
    }
  );
};
Rn.displayName = "GlobalFilter";
const Qe = 104, Gt = 256, Ao = (n) => {
  var t, e;
  return ((t = n.columnDef.meta) == null ? void 0 : t.columnSize) !== void 0 && ((e = n.columnDef.meta) == null ? void 0 : e.columnSize) !== "auto";
}, Vt = (n, t) => {
  if (!t) return;
  const e = n.getAllColumns(), r = e.filter(Ao).map((d) => {
    var u, h, m, f, g;
    if (typeof ((u = d.columnDef.meta) == null ? void 0 : u.columnSize) == "number")
      return {
        id: d.id,
        size: Math.max(
          (h = d.columnDef.meta) == null ? void 0 : h.columnSize,
          d.columnDef.minSize ?? Qe
        )
      };
    if (typeof ((m = d.columnDef.meta) == null ? void 0 : m.columnSize) == "string" && ((f = d.columnDef.meta) != null && f.columnSize.endsWith("%"))) {
      const w = Math.floor(
        t * parseFloat((g = d.columnDef.meta) == null ? void 0 : g.columnSize) / 100
      );
      return {
        id: d.id,
        size: Math.max(w, d.columnDef.minSize ?? Qe)
      };
    }
    return {
      id: d.id,
      size: d.columnDef.minSize ?? Qe
    };
  }), o = e.filter(
    (d) => {
      var u, h;
      return ((u = d.columnDef.meta) == null ? void 0 : u.columnSize) === void 0 || ((h = d.columnDef.meta) == null ? void 0 : h.columnSize) === "auto";
    }
  ).map((d) => ({
    id: d.id,
    size: d.columnDef.minSize ?? Qe
  })), a = r.reduce((d, u) => d + u.size, 0), s = o.reduce((d, u) => d + u.size, 0), l = t - a - s;
  o.length > 0 && l && o.forEach((d, u) => {
    d.size += Math.floor(l / o.length), u === o.length - 1 && (d.size += l % o.length);
  });
  const c = {};
  for (let d = 0; d < r.length; d++) {
    const u = r[d];
    u.size !== void 0 && (c[u.id] = u.size);
  }
  for (let d = 0; d < o.length; d++) {
    const u = o[d];
    c[u.id] = u.size;
  }
  return c;
}, Fo = (n) => {
  const { isSorted: t, ...e } = n;
  return t === "asc" ? /* @__PURE__ */ i(Ne, { as: Cn, size: "5x", marginLeft: "1x", ...e }) : t === "desc" ? /* @__PURE__ */ i(Ne, { as: Tn, size: "5x", marginLeft: "1x", ...e }) : null;
};
function jt(n, t) {
  var e = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function _o(n) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jt(Object(e), !0).forEach(function(r) {
      Yo(n, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : jt(Object(e)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return n;
}
function Lo(n, t) {
  if (typeof n != "object" || !n) return n;
  var e = n[Symbol.toPrimitive];
  if (e !== void 0) {
    var r = e.call(n, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(n);
}
function Wo(n) {
  var t = Lo(n, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Yo(n, t, e) {
  return t = Wo(t), t in n ? Object.defineProperty(n, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[t] = e, n;
}
var Ho = function(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return t == null ? [].concat(e) : Array.isArray(t) ? t : [].concat(t);
}, zo = function n(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return t == null || (t = Number(t), Number.isNaN(t)) ? n(e) : t;
}, Nn = function n(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return t = zo(t, e), typeof t == "number" && isFinite(t) ? t : n(e);
}, Qt = function(t) {
  return t > 0 ? "".concat(Math.round(t), "ms") : "";
}, Bo = {
  // most basic recommended timing
  standard: 300
}, An = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)"
}, qo = function(t) {
  var e, r, o, a, s, l, c = t.style, d = t.timeout, u = t.easing;
  return d = (e = (r = d) === null || r === void 0 ? void 0 : r.enter) !== null && e !== void 0 ? e : d, u = (o = (a = u) === null || a === void 0 ? void 0 : a.enter) !== null && o !== void 0 ? o : u, {
    duration: (s = c == null ? void 0 : c.transitionDuration) !== null && s !== void 0 ? s : typeof d == "number" ? Nn(d) : d || 0,
    easing: (l = c == null ? void 0 : c.transitionTimingFunction) !== null && l !== void 0 ? l : u,
    delay: c == null ? void 0 : c.transitionDelay
  };
}, $o = function(t) {
  var e, r, o, a, s, l, c = t.style, d = t.timeout, u = t.easing;
  return d = (e = (r = d) === null || r === void 0 ? void 0 : r.exit) !== null && e !== void 0 ? e : d, u = (o = (a = u) === null || a === void 0 ? void 0 : a.exit) !== null && o !== void 0 ? o : u, {
    duration: (s = c == null ? void 0 : c.transitionDuration) !== null && s !== void 0 ? s : typeof d == "number" ? Nn(d) : d || 0,
    easing: (l = c == null ? void 0 : c.transitionTimingFunction) !== null && l !== void 0 ? l : u,
    delay: c == null ? void 0 : c.transitionDelay
  };
}, Go = function(t, e) {
  var r;
  t = (r = t) !== null && r !== void 0 ? r : ["all"];
  var o = _o({}, e), a = o.duration, s = a === void 0 ? Bo.standard : a, l = o.easing, c = l === void 0 ? An.easeInOut : l, d = o.delay, u = d === void 0 ? 0 : d;
  return Ho(t).map(function(h) {
    var m = [h, typeof s == "string" ? s : Qt(s), c, typeof u == "string" ? u : Qt(u)].filter(function(f) {
      return f != null && f !== "";
    });
    return m.join(" ");
  }).join(",");
};
const Fn = ye(
  ({ isExpanded: n, ...t }, e) => {
    const r = n ? Math.floor(93.1) : 133, o = An.easeOut, a = n ? qo({ timeout: r, easing: o }) : $o({ timeout: r, easing: o }), s = {
      transform: n ? "rotate(90deg)" : "rotate(0deg)",
      transition: Go("transform", a)
    };
    return /* @__PURE__ */ i(fn, { ref: e, minHeight: "0", lineHeight: "0", ...t, children: /* @__PURE__ */ i(At, { size: "4x", ...s }) });
  }
);
Fn.displayName = "TableRowToggleIcon";
function Vo(n, t, e) {
  var r = this, o = H(null), a = H(0), s = H(null), l = H([]), c = H(), d = H(), u = H(n), h = H(!0);
  u.current = n;
  var m = typeof window < "u", f = !t && t !== 0 && m;
  if (typeof n != "function") throw new TypeError("Expected a function");
  t = +t || 0;
  var g = !!(e = e || {}).leading, w = !("trailing" in e) || !!e.trailing, x = "maxWait" in e, v = "debounceOnServer" in e && !!e.debounceOnServer, T = x ? Math.max(+e.maxWait || 0, t) : null;
  G(function() {
    return h.current = !0, function() {
      h.current = !1;
    };
  }, []);
  var y = se(function() {
    var p = function(k) {
      var O = l.current, _ = c.current;
      return l.current = c.current = null, a.current = k, d.current = u.current.apply(_, O);
    }, b = function(k, O) {
      f && cancelAnimationFrame(s.current), s.current = f ? requestAnimationFrame(k) : setTimeout(k, O);
    }, C = function(k) {
      if (!h.current) return !1;
      var O = k - o.current;
      return !o.current || O >= t || O < 0 || x && k - a.current >= T;
    }, E = function(k) {
      return s.current = null, w && l.current ? p(k) : (l.current = c.current = null, d.current);
    }, F = function k() {
      var O = Date.now();
      if (C(O)) return E(O);
      if (h.current) {
        var _ = t - (O - o.current), I = x ? Math.min(_, T - (O - a.current)) : _;
        b(k, I);
      }
    }, S = function() {
      if (m || v) {
        var k = Date.now(), O = C(k);
        if (l.current = [].slice.call(arguments), c.current = r, o.current = k, O) {
          if (!s.current && h.current) return a.current = o.current, b(F, t), g ? p(o.current) : d.current;
          if (x) return b(F, t), p(o.current);
        }
        return s.current || b(F, t), d.current;
      }
    };
    return S.cancel = function() {
      s.current && (f ? cancelAnimationFrame(s.current) : clearTimeout(s.current)), a.current = 0, l.current = o.current = c.current = s.current = null;
    }, S.isPending = function() {
      return !!s.current;
    }, S.flush = function() {
      return s.current ? E(Date.now()) : d.current;
    }, S;
  }, [g, x, t, T, w, f, m, v]);
  return y;
}
const jo = (n) => {
  try {
    const t = parseFloat(n);
    return isNaN(t) ? void 0 : t;
  } catch {
    return;
  }
}, Qo = (n, t, e) => Math.max(t, Math.min(n, e)), Uo = (n) => {
  const {
    cursor: t,
    layout: e,
    count: r = 1,
    defaultPage: o = 1,
    defaultRowsPerPage: a,
    onPageChange: s,
    onRowsPerPageChange: l,
    page: c,
    rowsPerPage: d,
    rowsPerPageOptions: u = [10, 25, 50, 100],
    getNextPage: h,
    hasNextPage: m,
    getPreviousPage: f,
    disabled: g,
    variant: w,
    backgroundColor: x,
    disablePageSelect: v = !1,
    disabledRowsPerPage: T = !1,
    disableTotalPages: y = !1
  } = n, p = a ?? Array.isArray(u) ? u[0] : void 0, [b, C] = R(c ?? o), [E, F] = R(d ?? p), S = H(), [k, O] = R(E + 1);
  G(() => {
    c !== void 0 && C(c);
  }, [c]), G(() => {
    d !== void 0 && F(d);
  }, [d]);
  const _ = Vo(() => {
    he(), S.current && S.current.blur();
  }, 4e3), I = (B) => {
    ve(B), _();
  }, z = N(
    (B) => {
      c !== void 0 || C(B), typeof s == "function" && s(B), t && O(k + E), B > b && (h == null || h()), B < b && (f == null || f());
    },
    [
      b,
      c,
      s,
      h,
      t,
      f,
      E,
      k
    ]
  ), Q = N(
    (B) => {
      d !== void 0 || F(B), typeof l == "function" && l(B);
    },
    [d, l]
  ), ve = (B) => {
    const De = jo(B.target.value);
    if (De === void 0) {
      z(b);
      return;
    }
    z(De);
  }, he = () => {
    _.cancel(), C(Qo(b, 1, me));
  }, fe = (B) => {
    if (B === void 0) {
      Q(E);
      return;
    }
    B > 0 && (z(1), O(B + 1), Q(B));
  }, me = Math.ceil(r / E), Ge = b > 1, Ve = b < me || m;
  return /* @__PURE__ */ D(
    q,
    {
      alignItems: "center",
      color: "white",
      backgroundColor: x,
      justifyContent: "flex-end",
      px: "6x",
      py: "3x",
      style: { ...g && { pointerEvents: "none" } },
      ...e === "inline" ? {} : { position: "sticky", bottom: "0" },
      children: [
        !y && /* @__PURE__ */ D(ee, { children: [
          /* @__PURE__ */ i(Z, { children: /* @__PURE__ */ i(un, { i18nKey: "Total: {{count}}", values: { count: r } }) }),
          /* @__PURE__ */ i(wt, { orientation: "vertical", height: "6x", marginLeft: "4x" })
        ] }),
        !T && /* @__PURE__ */ D(ee, { children: [
          /* @__PURE__ */ D(be, { placement: "top", children: [
            /* @__PURE__ */ D(nt, { variant: "ghost", children: [
              E,
              " per page"
            ] }),
            /* @__PURE__ */ i(xe, { width: "100%", children: u.map((B) => /* @__PURE__ */ i(oe, { onClick: () => fe(B), children: B }, B)) })
          ] }),
          /* @__PURE__ */ i(wt, { orientation: "vertical", height: "6x" })
        ] }),
        /* @__PURE__ */ i(Ie, { width: "4x" }),
        w === "offset" && !v && /* @__PURE__ */ i(ee, { children: /* @__PURE__ */ i(
          Ar,
          {
            ref: S,
            width: "10x",
            px: 0,
            textAlign: "center",
            onChange: I,
            onBlur: he,
            value: b
          }
        ) }),
        w === "offset" && /* @__PURE__ */ D(ee, { children: [
          /* @__PURE__ */ i(Z, { textAlign: "right", minWidth: `${me.toString().length}.1ch`, children: b }),
          /* @__PURE__ */ i(Ie, { width: "2x" }),
          /* @__PURE__ */ i(Z, { children: "/" }),
          /* @__PURE__ */ i(Ie, { width: "2x" }),
          /* @__PURE__ */ i(Z, { children: me }),
          /* @__PURE__ */ i(Ie, { width: "2x" })
        ] }),
        /* @__PURE__ */ D(
          Fr,
          {
            variant: "secondary",
            sx: {
              "> *:not(:first-of-type)": {
                marginLeft: -1
              }
            },
            children: [
              /* @__PURE__ */ i(
                ne,
                {
                  width: "8x",
                  disabled: !Ge || g,
                  onClick: () => {
                    z(b - 1);
                  },
                  children: /* @__PURE__ */ i(Ne, { as: oo })
                }
              ),
              /* @__PURE__ */ i(
                ne,
                {
                  width: "8x",
                  disabled: !Ve || g,
                  onClick: () => {
                    z(b + 1);
                  },
                  children: /* @__PURE__ */ i(Ne, { as: At })
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Xo = () => /* @__PURE__ */ i(yt, { paddingBottom: "11x", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ i(Re, { children: "No Data to Display" }) });
function xt() {
  return xt = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var r in e) ({}).hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, xt.apply(null, arguments);
}
function Ko(n) {
  for (var t = 0, e, r = 0, o = n.length; o >= 4; ++r, o -= 4)
    e = n.charCodeAt(r) & 255 | (n.charCodeAt(++r) & 255) << 8 | (n.charCodeAt(++r) & 255) << 16 | (n.charCodeAt(++r) & 255) << 24, e = /* Math.imul(k, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), e ^= /* k >>> r: */
    e >>> 24, t = /* Math.imul(k, m): */
    (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (n.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (n.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= n.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Jo = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function _n(n) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(e) {
    return t[e] === void 0 && (t[e] = n(e)), t[e];
  };
}
var Zo = /[A-Z]|^ms/g, ea = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Ln = function(t) {
  return t.charCodeAt(1) === 45;
}, Ut = function(t) {
  return t != null && typeof t != "boolean";
}, ut = /* @__PURE__ */ _n(function(n) {
  return Ln(n) ? n : n.replace(Zo, "-$&").toLowerCase();
}), Xt = function(t, e) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof e == "string")
        return e.replace(ea, function(r, o, a) {
          return le = {
            name: o,
            styles: a,
            next: le
          }, o;
        });
  }
  return Jo[t] !== 1 && !Ln(t) && typeof e == "number" && e !== 0 ? e + "px" : e;
};
function ze(n, t, e) {
  if (e == null)
    return "";
  var r = e;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof e) {
    case "boolean":
      return "";
    case "object": {
      var o = e;
      if (o.anim === 1)
        return le = {
          name: o.name,
          styles: o.styles,
          next: le
        }, o.name;
      var a = e;
      if (a.styles !== void 0) {
        var s = a.next;
        if (s !== void 0)
          for (; s !== void 0; )
            le = {
              name: s.name,
              styles: s.styles,
              next: le
            }, s = s.next;
        var l = a.styles + ";";
        return l;
      }
      return ta(n, t, e);
    }
    case "function": {
      if (n !== void 0) {
        var c = le, d = e(n);
        return le = c, ze(n, t, d);
      }
      break;
    }
  }
  var u = e;
  if (t == null)
    return u;
  var h = t[u];
  return h !== void 0 ? h : u;
}
function ta(n, t, e) {
  var r = "";
  if (Array.isArray(e))
    for (var o = 0; o < e.length; o++)
      r += ze(n, t, e[o]) + ";";
  else
    for (var a in e) {
      var s = e[a];
      if (typeof s != "object") {
        var l = s;
        t != null && t[l] !== void 0 ? r += a + "{" + t[l] + "}" : Ut(l) && (r += ut(a) + ":" + Xt(a, l) + ";");
      } else if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
        for (var c = 0; c < s.length; c++)
          Ut(s[c]) && (r += ut(a) + ":" + Xt(a, s[c]) + ";");
      else {
        var d = ze(n, t, s);
        switch (a) {
          case "animation":
          case "animationName": {
            r += ut(a) + ":" + d + ";";
            break;
          }
          default:
            r += a + "{" + d + "}";
        }
      }
    }
  return r;
}
var Kt = /label:\s*([^\s;{]+)\s*(;|$)/g, le;
function na(n, t, e) {
  if (n.length === 1 && typeof n[0] == "object" && n[0] !== null && n[0].styles !== void 0)
    return n[0];
  var r = !0, o = "";
  le = void 0;
  var a = n[0];
  if (a == null || a.raw === void 0)
    r = !1, o += ze(e, t, a);
  else {
    var s = a;
    o += s[0];
  }
  for (var l = 1; l < n.length; l++)
    if (o += ze(e, t, n[l]), r) {
      var c = a;
      o += c[l];
    }
  Kt.lastIndex = 0;
  for (var d = "", u; (u = Kt.exec(o)) !== null; )
    d += "-" + u[1];
  var h = Ko(o) + d;
  return {
    name: h,
    styles: o,
    next: le
  };
}
var ra = function(t) {
  return t();
}, oa = ke.useInsertionEffect ? ke.useInsertionEffect : !1, aa = oa || ra, ia = !0;
function sa(n, t, e) {
  var r = "";
  return e.split(" ").forEach(function(o) {
    n[o] !== void 0 ? t.push(n[o] + ";") : o && (r += o + " ");
  }), r;
}
var Wn = function(t, e, r) {
  var o = t.key + "-" + e.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  ia === !1) && t.registered[o] === void 0 && (t.registered[o] = e.styles);
}, ca = function(t, e, r) {
  Wn(t, e, r);
  var o = t.key + "-" + e.name;
  if (t.inserted[e.name] === void 0) {
    var a = e;
    do
      t.insert(e === a ? "." + o : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
}, la = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, da = /* @__PURE__ */ _n(
  function(n) {
    return la.test(n) || n.charCodeAt(0) === 111 && n.charCodeAt(1) === 110 && n.charCodeAt(2) < 91;
  }
  /* Z+1 */
), ua = da, ha = function(t) {
  return t !== "theme";
}, Jt = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? ua : ha;
}, Zt = function(t, e, r) {
  var o;
  if (e) {
    var a = e.shouldForwardProp;
    o = t.__emotion_forwardProp && a ? function(s) {
      return t.__emotion_forwardProp(s) && a(s);
    } : a;
  }
  return typeof o != "function" && r && (o = t.__emotion_forwardProp), o;
}, fa = function(t) {
  var e = t.cache, r = t.serialized, o = t.isStringTag;
  return Wn(e, r, o), aa(function() {
    return ca(e, r, o);
  }), null;
}, ma = function n(t, e) {
  var r = t.__emotion_real === t, o = r && t.__emotion_base || t, a, s;
  e !== void 0 && (a = e.label, s = e.target);
  var l = Zt(t, e, r), c = l || Jt(o), d = !c("as");
  return function() {
    var u = arguments, h = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && h.push("label:" + a + ";"), u[0] == null || u[0].raw === void 0)
      h.push.apply(h, u);
    else {
      var m = u[0];
      h.push(m[0]);
      for (var f = u.length, g = 1; g < f; g++)
        h.push(u[g], m[g]);
    }
    var w = mo(function(x, v, T) {
      var y = d && x.as || o, p = "", b = [], C = x;
      if (x.theme == null) {
        C = {};
        for (var E in x)
          C[E] = x[E];
        C.theme = ke.useContext(go);
      }
      typeof x.className == "string" ? p = sa(v.registered, b, x.className) : x.className != null && (p = x.className + " ");
      var F = na(h.concat(b), v.registered, C);
      p += v.key + "-" + F.name, s !== void 0 && (p += " " + s);
      var S = d && l === void 0 ? Jt(y) : c, k = {};
      for (var O in x)
        d && O === "as" || S(O) && (k[O] = x[O]);
      return k.className = p, T && (k.ref = T), /* @__PURE__ */ ke.createElement(ke.Fragment, null, /* @__PURE__ */ ke.createElement(fa, {
        cache: v,
        serialized: F,
        isStringTag: typeof y == "string"
      }), /* @__PURE__ */ ke.createElement(y, k));
    });
    return w.displayName = a !== void 0 ? a : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", w.defaultProps = t.defaultProps, w.__emotion_real = w, w.__emotion_base = o, w.__emotion_styles = h, w.__emotion_forwardProp = l, Object.defineProperty(w, "toString", {
      value: function() {
        return "." + s;
      }
    }), w.withComponent = function(x, v) {
      var T = n(x, xt({}, e, v, {
        shouldForwardProp: Zt(w, v, !0)
      }));
      return T.apply(void 0, h);
    }, w;
  };
}, ga = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], vt = ma.bind(null);
ga.forEach(function(n) {
  vt[n] = vt(n);
});
const pa = vt(
  W
)`
  /* Same CSS used by youtube homepage. Most modern browsers support */
  display: -webkit-box;
  -webkit-line-clamp: ${({ lineLimit: n }) => n};
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: break-word;
  word-break: break-word;
`, Ct = ye(
  (n, t) => {
    const { children: e, tooltipStyles: r, ...o } = n, a = H(null), s = yo(a, t), [l, c] = kn();
    return Je(
      () => a == null ? void 0 : a.current,
      "mouseenter",
      // It can be either 'mouseenter' or 'pointerenter'
      N(() => {
        var h, m;
        (((h = a.current) == null ? void 0 : h.scrollHeight) ?? 0) > (((m = a.current) == null ? void 0 : m.clientHeight) ?? 0) && c(!0);
      }, [c])
    ), Je(
      () => a == null ? void 0 : a.current,
      "mouseleave",
      // It can be either 'mouseleave' or 'pointerleave'
      N(() => {
        c(!1);
      }, [c])
    ), /* @__PURE__ */ i(
      mn,
      {
        isOpen: l,
        label: e,
        maxWidth: 480,
        overflowWrap: "break-word",
        whiteSpace: "normal",
        minWidth: "0",
        minHeight: "0",
        ...r,
        children: /* @__PURE__ */ i(pa, { ref: s, lineLimit: "2", ...o, children: e })
      }
    );
  }
);
Ct.displayName = "MultilineTruncateWithTooltip";
const wa = [], ya = {
  static: { position: "relative", height: "calc(100% -44px)" },
  inline: {}
}, ba = {
  static: { width: "100%", height: "100%", minWidth: 0, minHeight: 0, overflow: "hidden" },
  inline: { width: "100%", minWidth: 0 }
}, xa = {
  static: {
    position: "relative",
    flex: "1",
    minWidth: 0,
    minHeight: 0,
    overflow: "hidden"
  },
  inline: {
    position: "relative",
    minWidth: 0
  }
}, va = {
  static: { width: "100%", height: "100%", overflow: "hidden" },
  inline: { width: "100%" }
}, Ca = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
}, Yn = (n) => {
  const {
    layout: t = "static",
    data: e,
    columns: r,
    onSelectRow: o,
    showSearch: a = !1,
    SearchComponent: s,
    emptySearchDisplay: l,
    emptyState: c = /* @__PURE__ */ i(Xo, {}),
    selectedRow: d,
    pagination: u,
    isLoading: h,
    isFetching: m,
    autoSelectRow: f = !1,
    sorting: g,
    setSorting: w,
    manualSorting: x = !0,
    enableSortingRemoval: v = !1,
    isExpandable: T = !1,
    ExpandedComponent: y,
    ExpandedComponentProps: p,
    infiniteLoader: b,
    tableProps: C,
    tableHeaderProps: E,
    enableRowSelection: F = !1,
    rowSelection: S,
    setRowSelection: k,
    defaultSorting: O
  } = n, _ = !!b, [I] = Pe(), z = {
    dark: "rgba(255, 255, 255, 0.12)",
    light: "rgba(0, 0, 0, 0.12)"
  }[I], Q = {
    dark: "rgba(255, 255, 255, 0.08)",
    light: "rgba(0, 0, 0, 0.08)"
  }[I], ve = H(), he = H(0), fe = H({ prevWidth: 0, currWidth: 0 }), me = H(null), [Ge, Ve] = R(""), [B, De] = R(O ?? g ?? []), [Ce, st] = R(null), Me = N(
    (A) => {
      o && (st(A), o(A.original));
    },
    [o]
  ), hr = (A) => {
    const M = document.activeElement;
    A.key === "ArrowDown" ? (M == null ? void 0 : M.nextSibling).focus() : A.key === "ArrowUp" && (M == null ? void 0 : M.previousSibling).focus();
  }, Ht = se(() => {
    const A = {
      id: "$rowSelection",
      header: ({ table: K }) => /* @__PURE__ */ i(
        He,
        {
          checked: K.getIsAllRowsSelected(),
          indeterminate: K.getIsSomeRowsSelected(),
          onChange: K.getToggleAllRowsSelectedHandler()
        }
      ),
      cell: ({ row: K }) => /* @__PURE__ */ i(
        He,
        {
          checked: K.getIsSelected(),
          disabled: !K.getCanSelect(),
          indeterminate: K.getIsSomeSelected(),
          onChange: K.getToggleSelectedHandler()
        }
      ),
      meta: { columnSize: 48 }
    }, M = {
      id: "$rowExpand",
      header: () => null,
      enableSorting: !1,
      meta: { disableOverflow: !0, columnSize: 48 },
      cell: ({ row: K }) => {
        const ie = K.getCanExpand(), ct = K.getIsExpanded();
        return ie ? /* @__PURE__ */ i(
          Fn,
          {
            isExpanded: ct,
            style: { height: "36px", width: "36px" },
            onClick: K.getToggleExpandedHandler()
          }
        ) : null;
      }
    };
    let te = [...r];
    return T && (te = [M, ...te]), F && (te = [A, ...te]), te;
  }, [r, T, F]), [fr] = ro({
    skip: !_ || !(b != null && b.hasNextPage),
    // Disable when not infinite loader, or data is all fetched
    onChange: (A) => {
      var M;
      A && !m && (b != null && b.hasNextPage) && ((M = b == null ? void 0 : b.getNextPage) == null || M.call(b));
    }
  }), ae = Jr({
    data: e ?? wa,
    debugTable: !1,
    columns: Ht,
    defaultColumn: {
      size: void 0,
      minSize: 0
    },
    state: {
      sorting: B,
      globalFilter: Ge,
      ...F && { rowSelection: S }
    },
    enableSorting: !0,
    manualSorting: x,
    enableMultiSort: !1,
    enableSortingRemoval: v,
    onSortingChange: (A) => {
      w == null || w(A), De(A);
    },
    onGlobalFilterChange: Ve,
    ...F && {
      enableRowSelection: !0,
      onRowSelectionChange: k
    },
    getRowCanExpand: () => T,
    getCoreRowModel: no(),
    getExpandedRowModel: to(),
    getFilteredRowModel: eo(),
    getSortedRowModel: Zr()
  }), zt = ae.getRowModel().rows, mr = () => {
    if (!Ce) return;
    const A = document.getElementById("row-" + Ce.id);
    A == null || A.scrollIntoView({ inline: "center", behavior: "auto" });
  };
  G(() => {
    e && e.length > 0 && !Ce && f && Me(ae.getRowModel().rows[0]);
  }, [e, Ce, Me, ae, f]), G(() => {
    if (!o) return;
    const A = ae.getRowModel().rows.find((M) => M.original === d);
    A && Me(A);
  }, [o, d, Me, ae]), G(() => {
    mr();
  }, [B, Ge]), Bt(() => {
    const A = new ResizeObserver((M) => {
      const [te, K] = [M[0].contentRect.width, M[0].contentRect.height];
      if (fe.current.currWidth !== te && te > 0) {
        fe.current.prevWidth = fe.current.currWidth, fe.current.currWidth = te;
        const ie = Vt(ae, te);
        ie && (ae.setColumnSizing(ie), st((ct) => ct));
      }
    });
    return me.current && A.observe(me.current), () => {
      A.disconnect();
    };
  }, [ae]), Bt(() => {
    if (fe.current.currWidth > 0) {
      const A = Vt(ae, fe.current.currWidth);
      A && (ae.setColumnSizing(A), st((M) => M));
    }
  }, [ae, Ht]);
  const gr = t === "static" ? _r : Et, pr = ya[t], wr = ba[t], yr = xa[t], br = va[t];
  return /* @__PURE__ */ D(mt, { ...wr, children: [
    /* @__PURE__ */ i(W, { children: a && /* @__PURE__ */ i(Rn, { setGlobalFilter: Ve, SearchComponent: s }) }),
    /* @__PURE__ */ D(q, { ref: me, ...yr, children: [
      m && !_ && /* @__PURE__ */ i(
        q,
        {
          position: "absolute",
          top: 44,
          left: 0,
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          children: /* @__PURE__ */ i(pt, { size: "lg" })
        }
      ),
      !m && e && e.length === 0 && /* @__PURE__ */ i(
        q,
        {
          position: "absolute",
          top: 44,
          left: 0,
          width: "100%",
          height: "100%",
          minHeight: "64px",
          justifyContent: "center",
          alignItems: "center",
          children: c
        }
      ),
      fe.current.currWidth === 0 ? null : /* @__PURE__ */ i(gn, { layout: "flexbox", size: "md", ...br, ...C, children: /* @__PURE__ */ D(
        gr,
        {
          ...t === "static" && {
            sx: {
              // Prevents the vertical scrollbar from becoming hidden by header. This cuts it off making it a misleading indicator
              '[data-scrollbar-track="vertical"]': { top: 36 }
            },
            scrollTop: he.current,
            height: "100%",
            overflow: "visible",
            onUpdate: (A) => {
              he.current = A.scrollTop;
            }
          },
          children: [
            /* @__PURE__ */ i(
              pn,
              {
                ref: ve,
                minWidth: 0,
                zIndex: "1",
                minHeight: "0",
                width: "fit-content",
                ...t !== "inline" && {
                  position: "sticky",
                  top: "0",
                  backgroundColor: "gray:100"
                },
                ...E,
                style: {
                  ...h && t === "inline" && { marginBottom: "96px" }
                },
                children: ae.getHeaderGroups().map((A) => /* @__PURE__ */ i(Xe, { children: A.headers.map((M) => {
                  var te, K;
                  return /* @__PURE__ */ i(
                    Ke,
                    {
                      tabIndex: 0,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      userSelect: "none",
                      _hover: {
                        ...M.column.getCanSort() && { backgroundColor: "#303030" }
                      },
                      style: {
                        minWidth: 0,
                        // default 'auto' value is unsafe value when we want to clip content
                        width: M.getSize(),
                        cursor: M.column.getCanSort() ? "pointer" : "default"
                      },
                      onClick: M.column.getToggleSortingHandler(),
                      onKeyDown: (ie) => {
                        (ie == null ? void 0 : ie.key) === "Enter" && M.column.getCanSort() && (ie.stopPropagation(), M.column.toggleSorting());
                      },
                      children: M.isPlaceholder ? null : /* @__PURE__ */ D(
                        q,
                        {
                          alignItems: "center",
                          style: {
                            ...((te = M.column.columnDef.meta) == null ? void 0 : te.align) && {
                              alignSelf: Ca[M.column.columnDef.meta.align]
                            },
                            ...M.column.getIsSorted() ? { color: "white:primary" } : {}
                          },
                          children: [
                            typeof M.column.columnDef.header == "string" ? /* @__PURE__ */ i(
                              Ct,
                              {
                                color: M.column.getIsSorted() ? "white:primary" : void 0,
                                lineLimit: "2",
                                children: ((K = je(
                                  M.column.columnDef.header,
                                  M.getContext()
                                )) == null ? void 0 : K.toString()) ?? ""
                              }
                            ) : je(M.column.columnDef.header, M.getContext()),
                            /* @__PURE__ */ i(
                              Fo,
                              {
                                isSorted: M.column.getIsSorted(),
                                canSort: M.column.getCanSort(),
                                alignSelf: "flex-end",
                                color: "white:primary"
                              }
                            )
                          ]
                        }
                      )
                    },
                    M.id
                  );
                }) }, A.id))
              }
            ),
            !m && zt.length === 0 ? /* @__PURE__ */ i(W, { minHeight: "64px", children: l }) : /* @__PURE__ */ D(wn, { ...pr, children: [
              zt.map((A) => (
                // Add a wrapper around row to create common container for table row and expanded component
                /* @__PURE__ */ D(W, { children: [
                  /* @__PURE__ */ i(
                    Xe,
                    {
                      "data-id": "row-" + A.id,
                      tabIndex: 0,
                      _hover: { backgroundColor: z },
                      _selected: { backgroundColor: Q },
                      style: {
                        ...(Ce == null ? void 0 : Ce.id) === A.id && { backgroundColor: Q }
                      },
                      onClick: () => Me(A),
                      onKeyDown: (M) => {
                        (M == null ? void 0 : M.key) === "Enter" ? (M.stopPropagation(), Me(A)) : hr(M);
                      },
                      children: A.getVisibleCells().map((M) => {
                        var te, K, ie;
                        return /* @__PURE__ */ i(
                          Ke,
                          {
                            overflowX: "hidden",
                            overflowWrap: "break-word",
                            style: {
                              minWidth: 0,
                              // default 'auto' value is unsafe value when we want to clip content
                              width: M.column.getSize(),
                              ...!!((te = M.column.columnDef.meta) != null && te.disableOverflow) && {
                                padding: "0"
                              }
                            },
                            children: (K = M.column.columnDef.meta) != null && K.disableOverflow ? /* @__PURE__ */ i(ee, { children: je(M.column.columnDef.cell, M.getContext()) }) : (
                              // by default wrap all content with component that truncates content after wrapping two lines
                              /* @__PURE__ */ i(
                                Ct,
                                {
                                  style: {
                                    ...((ie = M.column.columnDef.meta) == null ? void 0 : ie.align) && {
                                      textAlign: M.column.columnDef.meta.align
                                    }
                                  },
                                  children: je(M.column.columnDef.cell, M.getContext())
                                }
                              )
                            )
                          },
                          M.id
                        );
                      })
                    }
                  ),
                  A.getCanExpand() && /* @__PURE__ */ i(W, { children: /* @__PURE__ */ i(It, { in: A.getIsExpanded(), unmountOnExit: !0, children: !!y && /* @__PURE__ */ i(y, { row: A.original, ...p }) }) })
                ] }, A.id)
              )),
              (b == null ? void 0 : b.hasNextPage) && /* @__PURE__ */ D(
                q,
                {
                  visibility: _ && m ? "visible" : "hidden",
                  alignItems: "center",
                  paddingY: "3x",
                  paddingLeft: "4x",
                  gap: "2x",
                  children: [
                    /* @__PURE__ */ i(pt, { size: "xs" }),
                    /* @__PURE__ */ i(Re, { children: "Loading ..." })
                  ]
                }
              ),
              _ && /* @__PURE__ */ i(W, { height: "1px", ref: fr })
            ] })
          ]
        }
      ) })
    ] }),
    u && /* @__PURE__ */ i(
      Uo,
      {
        layout: t,
        backgroundColor: u.backgroundColor,
        variant: u.type,
        defaultRowsPerPage: 10,
        count: u.count,
        rowsPerPage: u.rowsPerPage,
        onRowsPerPageChange: u.setRowsPerPage,
        onPageChange: u.setPage,
        page: u.page,
        getNextPage: u.getNextPage,
        hasNextPage: u.hasNextPage,
        disabled: m,
        disablePageSelect: u.disablePageSelect,
        disabledRowsPerPage: u.disabledRowsPerPage,
        disableTotalPages: u.disableTotalPages
      }
    )
  ] });
};
Yn.displayName = "Table";
const Ta = (n) => /* @__PURE__ */ i(Mn, { ErrorComponent: at, children: /* @__PURE__ */ i(Yn, { ...n }) });
Ta.displayName = "ErrorBoundaryTable";
const Hn = () => {
  const [n] = Pe();
  return rt({ colorMode: n });
}, ka = (n, t, e) => {
  var c, d;
  const r = H({
    timerID: void 0,
    startTime: Date.now()
  }), [o, a] = R(() => Date.now()), s = e ? o - (((c = r.current) == null ? void 0 : c.startTime) ?? Date.now()) > e : !1, l = N(() => {
    var u;
    if (!s && t && !((u = r.current) != null && u.timerID)) {
      const h = window.setInterval(() => {
        a(Date.now());
      }, n);
      return r.current && (r.current.timerID = h), h;
    }
  }, [n, t, s]);
  return G(() => {
    const u = l();
    return () => {
      window.clearInterval(u);
    };
  }, [l]), o - (((d = r.current) == null ? void 0 : d.startTime) ?? Date.now());
}, Pa = (n, t) => {
  ot(() => {
    const e = setTimeout(() => t(), n);
    return () => clearTimeout(e);
  });
}, qe = Fe((n) => {
  const { text: t, width: e, maxTooltipWidth: r = 480, tooltipStyles: o, label: a } = n, s = H(null), [l, c] = kn();
  return Je(
    () => s.current,
    "mouseenter",
    // It can be either 'mouseenter' or 'pointerenter'
    N(
      (d) => {
        var h, m;
        ((h = d.currentTarget) == null ? void 0 : h.scrollWidth) > ((m = d.currentTarget) == null ? void 0 : m.clientWidth) && c(!0);
      },
      [c]
    )
  ), Je(
    () => s.current,
    "mouseleave",
    // It can be either 'mouseleave' or 'pointerleave'
    N(() => {
      c(!1);
    }, [c])
  ), /* @__PURE__ */ i(W, { width: e, minWidth: "0", children: /* @__PURE__ */ i(
    mn,
    {
      isOpen: l,
      label: a ?? t,
      maxWidth: r,
      background: "gray:80",
      color: "white:secondary",
      overflowWrap: "break-word",
      whiteSpace: "normal",
      ...o,
      children: /* @__PURE__ */ i(Lr, { ref: s, children: t })
    }
  ) });
});
qe.displayName = "TruncateWithTooltip";
const Da = (n) => {
  const { data: t, columns: e, onSelectRow: r, id: o, defaultSort: a, selectedRow: s, ...l } = n, [c] = Pe(), [d] = Hn(), u = Wr(), [h, m] = R(s), [f, g] = R(a ?? []), w = {
    dark: "rgba(255, 255, 255, 0.12)",
    light: "rgba(0, 0, 0, 0.12)"
  }[c], x = {
    dark: "rgba(255, 255, 255, 0.08)",
    light: "rgba(0, 0, 0, 0.08)"
  }[c], v = N(
    (p) => p.sortable && f.find((b) => b.id === p.accessorKey),
    [f]
  );
  G(() => {
    m(s);
  }, [s]);
  const T = N(
    (p) => {
      r == null || r(p), m(p);
    },
    [r]
  ), y = se(() => {
    if (f.length > 0) {
      const p = f[0].desc, b = f[0].id;
      return t.sort((C, E) => {
        const F = E[b], S = C[b];
        return p ? F.localeCompare(S) : S.localeCompare(F);
      });
    }
    return t;
  }, [f, t]);
  return G(() => {
    t.length > 0 && !h && r && T(t[0]);
  }, [t, h, T, r]), /* @__PURE__ */ D(gn, { size: "md", "data-testid": o, width: "100%", ...l, children: [
    /* @__PURE__ */ i(pn, { children: /* @__PURE__ */ i(Xe, { width: "100%", children: e.map((p, b) => {
      const C = v(p);
      return /* @__PURE__ */ D(
        Ke,
        {
          display: "flex",
          ...p.sortable && {
            onClick: () => {
              const E = v(p);
              g(E ? [{ id: p.accessorKey, desc: !E.desc }] : [{ id: p.accessorKey, desc: !1 }]);
            }
          },
          ...p.sortable && { cursor: "pointer", userSelect: "none" },
          ...p.headerProps,
          style: {
            ...!!C && { color: u.colors[d.color.emphasis] }
          },
          children: [
            /* @__PURE__ */ i(qe, { text: p.header }),
            /* @__PURE__ */ i(ee, { children: !!C && {
              asc: /* @__PURE__ */ i(Cn, { size: "5x", ml: "1x" }),
              desc: /* @__PURE__ */ i(Tn, { size: "5x", ml: "1x" })
            }[C.desc ? "desc" : "asc"] })
          ]
        },
        b
      );
    }) }) }),
    /* @__PURE__ */ i(wn, { children: y.map((p, b) => /* @__PURE__ */ i(
      Xe,
      {
        _hover: { backgroundColor: w },
        width: "100%",
        style: h === p ? { backgroundColor: x } : {},
        onClick: () => T(p),
        children: e.map((C, E) => /* @__PURE__ */ i(Ke, { ...C.rowProps, children: C.cell ? C.cell({ value: p[C.accessorKey] }) : p[C.accessorKey] }, E))
      },
      b
    )) })
  ] });
};
Da.displayName = "SimpleTable";
const $e = (n) => {
  const { disabled: t, title: e, children: r, width: o, onClear: a, onClick: s, ...l } = n, [c] = Pe(), d = { dark: "gray:60", light: "gray:40" }[c];
  return /* @__PURE__ */ i(Be, { as: "div", width: o, onClick: s, children: ({ getMenuToggleProps: u }) => /* @__PURE__ */ D(
    Yr,
    {
      ...u(),
      isClosable: !0,
      borderRadius: "lg",
      marginLeft: "0",
      cursor: "pointer",
      flex: "1",
      minWidth: "0",
      columnGap: "1x",
      disabled: t,
      _hover: { backgroundColor: d },
      _disabled: { cursor: "not-allowed", userSelect: "none" },
      ...!!a && {
        onClose: (h) => {
          h.stopPropagation(), a == null || a();
        }
      },
      ...!t && { tabIndex: 0 },
      ...l,
      children: [
        /* @__PURE__ */ D(Z, { color: "gray:40", whiteSpace: "nowrap", children: [
          e,
          ":"
        ] }),
        r
      ]
    }
  ) });
};
$e.displayName = "FilterTag";
const zn = (n) => {
  const { displayValue: t, title: e, disabled: r, ...o } = n;
  return /* @__PURE__ */ i(
    nt,
    {
      variant: "secondary",
      disabled: r,
      textAlign: "left",
      sx: { "> div:first-of-type": { minWidth: 0, flex: 1 } },
      ...o,
      children: /* @__PURE__ */ D(q, { minWidth: "0", flex: "1", children: [
        /* @__PURE__ */ i(Z, { color: "white:secondary", marginRight: "2x", children: `${e}:` }),
        /* @__PURE__ */ i(W, { minWidth: "0", flex: "1", children: /* @__PURE__ */ i(qe, { text: t }) })
      ] })
    }
  );
};
zn.displayName = "DropdownButton";
const Ma = ({
  children: n,
  highlightSelectedOption: t = !1,
  options: e = [],
  defaultIsOpen: r,
  offset: o,
  onChange: a,
  renderOption: s,
  value: l,
  onClose: c,
  ...d
}) => {
  const [u, h] = R(l ?? void 0);
  G(() => {
    h(l ?? void 0);
  }, [l]);
  const m = N(
    (f) => {
      l === void 0 && h(f), a == null || a(f);
    },
    [l, a]
  );
  return /* @__PURE__ */ D(
    be,
    {
      offset: o,
      defaultIsOpen: r,
      onClose: c,
      minWidth: "200px",
      ...d,
      children: [
        /* @__PURE__ */ i(Be, { as: "div", children: n }),
        /* @__PURE__ */ i(xe, { width: "100%", children: e.map((f) => /* @__PURE__ */ i(
          oe,
          {
            "data-selected": t ? u === f : void 0,
            onClick: () => m(f),
            children: s(f)
          },
          f
        )) })
      ]
    }
  );
};
Ma.displayName = "Dropdown";
const Sa = (n) => {
  const {
    title: t,
    options: e,
    value: r,
    onApply: o,
    onClose: a,
    width: s,
    MenuGroupComponent: l = Hr,
    renderOption: c,
    renderGroup: d,
    renderLabel: u,
    idField: h,
    labelField: m,
    defaultLabel: f,
    variant: g = "dropdown",
    maxHeight: w = "38vh",
    borderRadius: x,
    disabled: v,
    usePortal: T
  } = n, y = H(r), p = N(
    (C) => typeof C == "string" ? C : C == null ? void 0 : C[h],
    [h]
  ), b = N(
    (C) => typeof C == "string" ? C : C == null ? void 0 : C[m],
    [m]
  );
  return /* @__PURE__ */ D(
    be,
    {
      defaultIsOpen: g === "tag",
      onClose: () => {
        !n.value && !y.current && o(void 0), a == null || a();
      },
      children: [
        g === "tag" ? /* @__PURE__ */ i($e, { title: t, onClear: () => o == null ? void 0 : o(void 0), children: /* @__PURE__ */ i(W, { minWidth: "0", children: /* @__PURE__ */ i(
          qe,
          {
            tooltipStyles: {
              PopperProps: { usePortal: !0, maxHeight: "50vh", overflow: "hidden" },
              maxWidth: "350px"
            },
            text: (u == null ? void 0 : u(r)) ?? b(r) ?? f ?? ""
          }
        ) }) }) : /* @__PURE__ */ i(
          zn,
          {
            disabled: v,
            width: s,
            title: t,
            displayValue: (u == null ? void 0 : u(r)) ?? b(r) ?? f ?? "",
            ...x ? { borderRadius: x } : {}
          }
        ),
        /* @__PURE__ */ i(
          xe,
          {
            paddingTop: "0",
            width: "100%",
            maxHeight: w,
            overflowY: "auto",
            ...T && { PopperProps: { usePortal: !0 }, width: "max-content" },
            children: e.map(
              (C, E) => typeof C == "object" && C && "group" in C ? /* @__PURE__ */ i(Et, { children: /* @__PURE__ */ i(l, { title: (d == null ? void 0 : d(C.group)) ?? C.group, children: C.groupOptions.map((F, S) => {
                const k = p(r) === p(F);
                return /* @__PURE__ */ i(
                  oe,
                  {
                    "data-selected": k || void 0,
                    wordBreak: "break-word",
                    paddingLeft: "6x",
                    onClick: () => {
                      y.current = F, o(F);
                    },
                    children: (c == null ? void 0 : c(F)) ?? b(F)
                  },
                  S
                );
              }) }) }, E) : /* @__PURE__ */ i(
                oe,
                {
                  "data-selected": p(r) === p(C) || void 0,
                  wordBreak: "break-word",
                  onClick: () => {
                    y.current = C, o(C);
                  },
                  children: (c == null ? void 0 : c(C)) ?? b(C)
                },
                E
              )
            )
          }
        )
      ]
    }
  );
};
Sa.displayName = "DropdownFilter";
const it = ye((n, t) => {
  const {
    trim: e = !0,
    onChange: r,
    value: o,
    onKeyDown: a,
    debounceTime: s = 250,
    ...l
  } = n, [c, d] = R(o);
  G(() => {
    const f = e ? c.trim() : c, g = setTimeout(() => {
      r(f);
    }, s);
    return () => {
      clearTimeout(g);
    };
  }, [s, r, c, e]), G(() => {
    d((f) => o.trim() !== f.trim() ? o : f);
  }, [o]);
  const u = N(
    (f) => {
      ["Enter", "NumpadEnter"].includes(f.key) && r(e ? c.trim() : c), a == null || a(f);
    },
    [a, c, r, e]
  ), h = N((f) => {
    d(f.currentTarget.value);
  }, []), m = N(() => {
    r("");
  }, [r]);
  return /* @__PURE__ */ i(
    hn,
    {
      ref: t,
      variant: "outline",
      width: "100%",
      value: c,
      onChange: h,
      onClearInput: m,
      onKeyDown: u,
      ...l
    }
  );
});
it.displayName = "SearchInput";
const Oa = Object.freeze([]), Bn = ({
  children: n,
  options: t = Oa,
  onChange: e,
  shouldSelectAllIfNoneSelected: r = !1,
  selected: o,
  inlineSearch: a = !1,
  maxHeight: s,
  renderOption: l,
  idField: c,
  labelField: d,
  // TODO: Want to pull the  menu button into this component so we can implement loader and disabled states
  // disabled = false,
  // showLoader = false,
  usePortal: u,
  ...h
}) => {
  const m = H(), f = N(
    (I) => typeof I == "string" ? I : I[c],
    [c]
  ), g = N(
    (I) => typeof I == "string" ? I : I[d],
    [d]
  ), [w, x] = R(o || []), [v, T] = R(""), { t: y } = ce(), p = w.length === t.length, b = w.length === 0, C = se(() => t.filter(
    (I) => g(I).toLowerCase().includes(v.toLowerCase())
  ), [g, t, v]);
  G(() => {
    o !== void 0 && x(o);
  }, [o]);
  const E = N(
    (I) => {
      typeof (I == null ? void 0 : I[0]) == "string" ? x(t.filter((z) => I.includes(f(z)))) : x(
        t.filter((z) => I.find((Q) => f(Q) === f(z)))
      );
    },
    [f, t]
  ), F = () => {
    x(p ? [] : t);
  }, S = (I) => {
    ["Enter", "NumpadEnter", "Space"].includes(I.code) && F();
  }, k = N(
    (I, z) => {
      if (["Enter", "NumpadEnter", "Space"].includes(I.code))
        if (w.includes(z))
          E(w.filter((Q) => Q !== z));
        else {
          const Q = [...w, z];
          E(
            t.filter((ve) => !!Q.find((he) => f(he) === f(ve)))
          );
        }
    },
    [f, E, t, w]
  ), O = N((I) => {
    ["Tab"].includes(I.code) || I.stopPropagation();
  }, []), _ = se(() => C.map((I, z) => /* @__PURE__ */ i(
    oe,
    {
      paddingX: "0",
      paddingY: "0",
      onKeyDown: (Q) => k(Q, I),
      children: /* @__PURE__ */ i(
        He,
        {
          value: f(I),
          paddingX: "3x",
          size: "sm",
          paddingY: "2x",
          width: "100%",
          children: (l == null ? void 0 : l(I)) ?? g(I)
        }
      )
    },
    z
  )), [C, f, g, k, l]);
  return /* @__PURE__ */ D(
    be,
    {
      closeOnSelect: !1,
      minWidth: "0",
      onClose: () => {
        b && r ? (x(t), e == null || e(t)) : Eo(o, w) || e == null || e(w);
      },
      ...h,
      children: [
        /* @__PURE__ */ i(ee, { children: n }),
        /* @__PURE__ */ D(
          xe,
          {
            width: "100%",
            ...u && { PopperProps: { usePortal: !0 }, width: "max-content" },
            children: [
              a && /* @__PURE__ */ i(oe, { as: "div", onFocus: () => {
                var I;
                return (I = m.current) == null ? void 0 : I.focus();
              }, children: /* @__PURE__ */ i(
                it,
                {
                  ref: m,
                  width: "100%",
                  value: v,
                  onChange: T,
                  onKeyDown: O
                }
              ) }),
              /* @__PURE__ */ D(
                yn,
                {
                  name: "filters",
                  size: "sm",
                  value: w.map((I) => f(I)),
                  onChange: E,
                  children: [
                    /* @__PURE__ */ i(
                      oe,
                      {
                        as: "div",
                        paddingX: "0",
                        paddingY: "0",
                        _hover: { background: "" },
                        onKeyDown: S,
                        children: /* @__PURE__ */ i(
                          Rt,
                          {
                            size: "sm",
                            as: "div",
                            onClick: F,
                            paddingX: "3x",
                            paddingY: "2x",
                            width: "100%",
                            children: y(p ? "Clear All" : "Select All")
                          },
                          "toggle"
                        )
                      }
                    ),
                    /* @__PURE__ */ i(bn, { maxHeight: s, overflowY: "auto", children: _ })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
};
Bn.displayName = "Multiselect";
const Ea = (n) => /* @__PURE__ */ i(W, { as: "ol", display: "flex", flexDirection: "column", ...n });
Ea.displayName = "Ol";
const Ft = (n) => /* @__PURE__ */ i(W, { as: "ul", display: "flex", flexDirection: "column", ...n });
Ft.displayName = "Ul";
const _t = (n) => /* @__PURE__ */ i(W, { as: "li", ...n });
_t.displayName = "Li";
const Ia = (n) => /* @__PURE__ */ i(W, { as: "p", ...n });
Ia.displayName = "P";
const Ra = (n) => {
  const {
    title: t,
    options: e,
    onClose: r,
    width: o,
    isFetching: a = !1,
    inlineSearch: s,
    disabled: l,
    maxHeight: c = "38vh",
    renderOption: d,
    idField: u,
    labelField: h,
    variant: m,
    onChange: f,
    value: g,
    usePortal: w,
    allowNone: x = !1
  } = n, v = N(
    (S) => typeof S == "string" ? S : S[u],
    [u]
  ), T = N(
    (S) => typeof S == "string" ? S : S[h],
    [h]
  ), [y, p] = R(
    g && g.length > 0 || x ? e == null ? void 0 : e.filter((S) => !!(g != null && g.find((k) => v(k) === v(S)))) : e
  );
  G(() => {
    p(
      g && g.length > 0 || x ? e == null ? void 0 : e.filter(
        (S) => !!(g != null && g.find((k) => v(k) === v(S)))
      ) : e
    );
  }, [g, e, v, x]);
  const b = N(
    (S) => {
      g === void 0 && p(S), f == null || f(S);
    },
    [g, f]
  ), { t: C } = ce(), E = (S) => {
    var I;
    const k = (y == null ? void 0 : y.length) ?? 0, O = k === (e == null ? void 0 : e.length);
    if (x && k === 0)
      return;
    if (O || k === 0)
      return /* @__PURE__ */ i(ee, { children: /* @__PURE__ */ i(W, { flex: "1", children: C("All") }) });
    const _ = ((I = S == null ? void 0 : S.map((z) => (d == null ? void 0 : d(z)) ?? T(z))) == null ? void 0 : I.join(On)) ?? "";
    return /* @__PURE__ */ D(ee, { children: [
      /* @__PURE__ */ i(W, { minWidth: "0", children: /* @__PURE__ */ i(
        qe,
        {
          tooltipStyles: {
            PopperProps: { usePortal: !0, maxHeight: "50vh", overflow: "hidden" },
            maxWidth: "350px"
          },
          text: _,
          label: /* @__PURE__ */ i(Ft, { marginY: "2x", children: S == null ? void 0 : S.map((z, Q) => /* @__PURE__ */ i(_t, { children: (d == null ? void 0 : d(z)) ?? T(z) }, Q)) })
        }
      ) }),
      /* @__PURE__ */ i(Z, { marginLeft: "1x", children: `(${k})` })
    ] });
  }, F = m === "tag" ? /* @__PURE__ */ i(
    $e,
    {
      title: t,
      onClear: () => {
        p([...e ?? []]), b([]), r == null || r();
      },
      children: y || !e ? E(y) : /* @__PURE__ */ i(W, {})
    }
  ) : /* @__PURE__ */ i(
    nt,
    {
      "data-testid": `checklist-filter-menu-toggle-${t}`,
      variant: "secondary",
      disabled: l || !e,
      textAlign: "left",
      sx: { "> div:first-of-type": { minWidth: 0, flex: 1 } },
      width: o ?? "100%",
      children: /* @__PURE__ */ D(q, { minWidth: "0", flex: "1", children: [
        /* @__PURE__ */ i(Z, { color: "white:secondary", marginRight: "2x", children: `${t}:` }),
        y || !e ? E(y) : /* @__PURE__ */ i(W, {})
      ] })
    }
  );
  return /* @__PURE__ */ i(
    Bn,
    {
      inlineSearch: s,
      disabled: l || !e,
      isFetching: a,
      selected: y,
      maxHeight: c,
      onChange: b,
      options: e,
      idField: u,
      labelField: h,
      renderOption: d,
      shouldSelectAllIfNoneSelected: !x,
      defaultIsOpen: m === "tag",
      usePortal: w,
      children: F
    }
  );
}, Na = Fe(Ra);
Na.displayName = "CheckListFilter";
const pe = (n, t) => {
  let e = [];
  return n == null || n.forEach((r) => {
    (!t || (t == null ? void 0 : t.length) === 0 || t.includes(r.value)) && e.push(r.value), r.children && (e = e.concat(pe(r.children, t)));
  }), e;
}, qn = ye(
  ({
    children: n,
    options: t,
    values: e = [],
    onChange: r,
    shouldSelectAllIfNoneSelected: o = !1,
    selected: a,
    inlineSearch: s = !1,
    ...l
  }, c) => {
    const d = H(), [u, h] = R(a || []), [m, f] = R(""), [g, w] = R(new Set(t)), { t: x } = ce(), v = u.length === e.length, T = u.length === 0;
    Pn(
      () => {
        w(new Set(t));
      },
      (t ?? []).length > 0
    );
    const y = se(() => t == null ? void 0 : t.filter(
      (k) => {
        var O;
        return k.label.toLowerCase().includes(m.toLowerCase()) || ((O = k.children) == null ? void 0 : O.some(
          (_) => _.label.toLowerCase().includes(m.toLowerCase())
        ));
      }
    ), [t, m]);
    G(() => {
      a !== void 0 && h(a);
    }, [a]);
    const p = N((k) => {
      h(k);
    }, []), b = () => {
      h(v ? [] : e);
    }, C = (k) => {
      ["Enter", "NumpadEnter", "Space"].includes(k.code) && b();
    }, E = (k, O) => {
      if (["Enter", "NumpadEnter", "Space"].includes(k.code))
        if (u.includes(O))
          p(u.filter((_) => _ !== O));
        else {
          const _ = [...u, O];
          p(_);
        }
    }, F = N((k) => {
      ["Tab"].includes(k.code) || k.stopPropagation();
    }, []), S = (k) => {
      w((O) => {
        const _ = new Set(O);
        return _.has(k) ? _.delete(k) : _.add(k), _;
      });
    };
    return /* @__PURE__ */ D(
      be,
      {
        ref: c,
        closeOnSelect: !1,
        onClose: () => {
          T && o ? (h(e), r == null || r(e)) : r == null || r(u);
        },
        ...l,
        children: [
          n,
          /* @__PURE__ */ D(xe, { width: "100%", children: [
            s && /* @__PURE__ */ i(oe, { as: "div", onFocus: () => {
              var k;
              return (k = d.current) == null ? void 0 : k.focus();
            }, children: /* @__PURE__ */ i(
              it,
              {
                ref: d,
                width: "100%",
                value: m,
                onChange: f,
                onKeyDown: F
              }
            ) }),
            /* @__PURE__ */ D(yn, { name: "filters", size: "sm", value: u, onChange: p, children: [
              /* @__PURE__ */ i(
                oe,
                {
                  as: "div",
                  paddingX: "0",
                  paddingY: "0",
                  _hover: { background: "" },
                  onKeyDown: C,
                  children: /* @__PURE__ */ i(
                    Rt,
                    {
                      size: "sm",
                      as: "div",
                      onClick: b,
                      paddingX: "3x",
                      paddingY: "2x",
                      width: "100%",
                      children: x(v ? "Clear All" : "Select All")
                    },
                    "toggle"
                  )
                }
              ),
              /* @__PURE__ */ i(bn, { maxHeight: "48vh", overflowY: "auto", children: y == null ? void 0 : y.map((k, O) => {
                var z;
                const _ = g.has(k), I = k.children && k.children.length > 0;
                return /* @__PURE__ */ D(W, { children: [
                  /* @__PURE__ */ i(
                    oe,
                    {
                      paddingX: "0",
                      paddingY: "0",
                      wordBreak: "break-word",
                      onKeyDown: (Q) => E(Q, k.value),
                      children: /* @__PURE__ */ D(q, { width: "100%", paddingX: "3x", alignItems: "center", children: [
                        /* @__PURE__ */ i(q, { width: "4x", children: I && /* @__PURE__ */ i(
                          Ne,
                          {
                            as: _ ? ao : io,
                            onClick: () => S(k),
                            size: "4x",
                            color: "white:secondary"
                          }
                        ) }),
                        /* @__PURE__ */ i(
                          He,
                          {
                            value: k.value,
                            paddingX: "3x",
                            size: "md",
                            paddingY: "2x",
                            width: "100%",
                            children: k.label
                          }
                        )
                      ] })
                    },
                    O
                  ),
                  I && /* @__PURE__ */ i(It, { in: _, children: (z = k.children) == null ? void 0 : z.map((Q, ve) => /* @__PURE__ */ i(
                    oe,
                    {
                      paddingLeft: "12x",
                      paddingY: "0",
                      width: "100%",
                      wordBreak: "break-word",
                      onKeyDown: (he) => E(he, Q.value),
                      children: /* @__PURE__ */ i(
                        He,
                        {
                          value: Q.value,
                          size: "md",
                          paddingX: "3x",
                          paddingY: "2x",
                          width: "100%",
                          children: Q.label
                        }
                      )
                    },
                    ve
                  )) })
                ] }, k.value);
              }) })
            ] })
          ] })
        ]
      }
    );
  }
);
qn.displayName = "MultiselectTree";
const Aa = Fe((n) => {
  var x;
  const {
    title: t,
    options: e,
    onApply: r,
    width: o,
    isFetching: a = !1,
    inlineSearch: s,
    defaultFilters: l,
    disabled: c,
    shouldSelectAllIfNoneSelected: d = !0,
    values: u
  } = n, { t: h } = ce(), [m, f] = R(
    l && l.length > 0 ? (x = pe(e)) == null ? void 0 : x.filter((v) => l.includes(v)) : pe(e)
  );
  G(() => {
    u && f(u);
  }, [u]), Pn(
    () => {
      var v;
      f(
        l && l.length > 0 ? (v = pe(e)) == null ? void 0 : v.filter((T) => l.includes(T)) : pe(e)
      );
    },
    (e ?? []).length > 0
  );
  const g = (v, T) => {
    for (const y of T || []) {
      if (y.value === v)
        return y.label;
      if (y.children) {
        const p = g(v, y.children);
        if (p)
          return p;
      }
    }
  }, w = (v) => {
    var C;
    const T = (m == null ? void 0 : m.length) ?? 0;
    if (T === ((C = pe(e || [])) == null ? void 0 : C.length) || d && T === 0)
      return /* @__PURE__ */ D(ee, { children: [
        /* @__PURE__ */ i(lt, { mr: "2x", children: `${t}:` }),
        /* @__PURE__ */ i(W, { flex: "1", children: h("All") })
      ] });
    if (!d && T === 0)
      return /* @__PURE__ */ D(ee, { children: [
        /* @__PURE__ */ i(lt, { mr: "2x", children: `${t}:` }),
        /* @__PURE__ */ i(W, { flex: "1", children: h("None") })
      ] });
    const p = v == null ? void 0 : v.map((E) => g(E, e)), b = (p == null ? void 0 : p.join(On)) ?? "";
    return /* @__PURE__ */ D(ee, { children: [
      /* @__PURE__ */ i(lt, { mr: "2x", children: `${t}:` }),
      /* @__PURE__ */ i(
        Nt,
        {
          PopperProps: { usePortal: !0, maxHeight: "50vh", overflow: "hidden" },
          label: /* @__PURE__ */ i(Ft, { marginY: "4x", children: p == null ? void 0 : p.map((E, F) => /* @__PURE__ */ i(_t, { children: E }, F)) }),
          maxWidth: "350px",
          overflow: "hidden",
          wordBreak: "break-word",
          children: b
        }
      ),
      /* @__PURE__ */ i(Z, { ml: "1x", children: `(${T})` })
    ] });
  };
  return /* @__PURE__ */ i(
    qn,
    {
      inlineSearch: s,
      disabled: c || !e,
      isFetching: a,
      selected: m,
      onChange: (v) => {
        const T = v.length === 0 ? [] : pe(e, v);
        f(T), r(T);
      },
      options: e,
      values: pe(e),
      shouldSelectAllIfNoneSelected: d,
      children: /* @__PURE__ */ i(
        nt,
        {
          variant: "secondary",
          width: o,
          disabled: c || !e,
          sx: { "> div": { minWidth: 0 } },
          children: /* @__PURE__ */ i(q, { minWidth: "0", maxWidth: o, children: m || !e ? w(m) : /* @__PURE__ */ i(W, {}) })
        }
      )
    }
  );
});
Aa.displayName = "CheckListTreeFilter";
function J(n) {
  const t = Object.prototype.toString.call(n);
  return n instanceof Date || typeof n == "object" && t === "[object Date]" ? new n.constructor(+n) : typeof n == "number" || t === "[object Number]" || typeof n == "string" || t === "[object String]" ? new Date(n) : /* @__PURE__ */ new Date(NaN);
}
function V(n, t) {
  return n instanceof Date ? new n.constructor(t) : new Date(t);
}
function $n(n, t) {
  const e = J(n);
  return isNaN(t) ? V(n, NaN) : (t && e.setDate(e.getDate() + t), e);
}
const Gn = 6048e5, Fa = 864e5, _a = 6e4, La = 36e5, Wa = 1e3;
let Ya = {};
function _e() {
  return Ya;
}
function we(n, t) {
  var l, c, d, u;
  const e = _e(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((c = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : c.weekStartsOn) ?? e.weekStartsOn ?? ((u = (d = e.locale) == null ? void 0 : d.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = J(n), a = o.getDay(), s = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - s), o.setHours(0, 0, 0, 0), o;
}
function Ae(n) {
  return we(n, { weekStartsOn: 1 });
}
function Vn(n) {
  const t = J(n), e = t.getFullYear(), r = V(n, 0);
  r.setFullYear(e + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = Ae(r), a = V(n, 0);
  a.setFullYear(e, 0, 4), a.setHours(0, 0, 0, 0);
  const s = Ae(a);
  return t.getTime() >= o.getTime() ? e + 1 : t.getTime() >= s.getTime() ? e : e - 1;
}
function en(n) {
  const t = J(n);
  return t.setHours(0, 0, 0, 0), t;
}
function Ze(n) {
  const t = J(n), e = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return e.setUTCFullYear(t.getFullYear()), +n - +e;
}
function Ha(n, t) {
  const e = en(n), r = en(t), o = +e - Ze(e), a = +r - Ze(r);
  return Math.round((o - a) / Fa);
}
function za(n) {
  const t = Vn(n), e = V(n, 0);
  return e.setFullYear(t, 0, 4), e.setHours(0, 0, 0, 0), Ae(e);
}
function Ba(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function jn(n) {
  if (!Ba(n) && typeof n != "number")
    return !1;
  const t = J(n);
  return !isNaN(Number(t));
}
function qa(n) {
  const t = J(n), e = V(n, 0);
  return e.setFullYear(t.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
const $a = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ga = (n, t, e) => {
  let r;
  const o = $a[n];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ht(n) {
  return (t = {}) => {
    const e = t.width ? String(t.width) : n.defaultWidth;
    return n.formats[e] || n.formats[n.defaultWidth];
  };
}
const Va = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ja = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Qa = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ua = {
  date: ht({
    formats: Va,
    defaultWidth: "full"
  }),
  time: ht({
    formats: ja,
    defaultWidth: "full"
  }),
  dateTime: ht({
    formats: Qa,
    defaultWidth: "full"
  })
}, Xa = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ka = (n, t, e, r) => Xa[n];
function Le(n) {
  return (t, e) => {
    const r = e != null && e.context ? String(e.context) : "standalone";
    let o;
    if (r === "formatting" && n.formattingValues) {
      const s = n.defaultFormattingWidth || n.defaultWidth, l = e != null && e.width ? String(e.width) : s;
      o = n.formattingValues[l] || n.formattingValues[s];
    } else {
      const s = n.defaultWidth, l = e != null && e.width ? String(e.width) : n.defaultWidth;
      o = n.values[l] || n.values[s];
    }
    const a = n.argumentCallback ? n.argumentCallback(t) : t;
    return o[a];
  };
}
const Ja = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Za = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ei = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ti = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ni = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ri = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, oi = (n, t) => {
  const e = Number(n), r = e % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}, ai = {
  ordinalNumber: oi,
  era: Le({
    values: Ja,
    defaultWidth: "wide"
  }),
  quarter: Le({
    values: Za,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: Le({
    values: ei,
    defaultWidth: "wide"
  }),
  day: Le({
    values: ti,
    defaultWidth: "wide"
  }),
  dayPeriod: Le({
    values: ni,
    defaultWidth: "wide",
    formattingValues: ri,
    defaultFormattingWidth: "wide"
  })
};
function We(n) {
  return (t, e = {}) => {
    const r = e.width, o = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const s = a[0], l = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], c = Array.isArray(l) ? si(l, (h) => h.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      ii(l, (h) => h.test(s))
    );
    let d;
    d = n.valueCallback ? n.valueCallback(c) : c, d = e.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      e.valueCallback(d)
    ) : d;
    const u = t.slice(s.length);
    return { value: d, rest: u };
  };
}
function ii(n, t) {
  for (const e in n)
    if (Object.prototype.hasOwnProperty.call(n, e) && t(n[e]))
      return e;
}
function si(n, t) {
  for (let e = 0; e < n.length; e++)
    if (t(n[e]))
      return e;
}
function ci(n) {
  return (t, e = {}) => {
    const r = t.match(n.matchPattern);
    if (!r) return null;
    const o = r[0], a = t.match(n.parsePattern);
    if (!a) return null;
    let s = n.valueCallback ? n.valueCallback(a[0]) : a[0];
    s = e.valueCallback ? e.valueCallback(s) : s;
    const l = t.slice(o.length);
    return { value: s, rest: l };
  };
}
const li = /^(\d+)(th|st|nd|rd)?/i, di = /\d+/i, ui = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, hi = {
  any: [/^b/i, /^(a|c)/i]
}, fi = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, mi = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gi = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, pi = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, wi = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, yi = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, bi = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, xi = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, vi = {
  ordinalNumber: ci({
    matchPattern: li,
    parsePattern: di,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: We({
    matchPatterns: ui,
    defaultMatchWidth: "wide",
    parsePatterns: hi,
    defaultParseWidth: "any"
  }),
  quarter: We({
    matchPatterns: fi,
    defaultMatchWidth: "wide",
    parsePatterns: mi,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: We({
    matchPatterns: gi,
    defaultMatchWidth: "wide",
    parsePatterns: pi,
    defaultParseWidth: "any"
  }),
  day: We({
    matchPatterns: wi,
    defaultMatchWidth: "wide",
    parsePatterns: yi,
    defaultParseWidth: "any"
  }),
  dayPeriod: We({
    matchPatterns: bi,
    defaultMatchWidth: "any",
    parsePatterns: xi,
    defaultParseWidth: "any"
  })
}, Qn = {
  code: "en-US",
  formatDistance: Ga,
  formatLong: Ua,
  formatRelative: Ka,
  localize: ai,
  match: vi,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Ci(n) {
  const t = J(n);
  return Ha(t, qa(t)) + 1;
}
function Un(n) {
  const t = J(n), e = +Ae(t) - +za(t);
  return Math.round(e / Gn) + 1;
}
function Lt(n, t) {
  var u, h, m, f;
  const e = J(n), r = e.getFullYear(), o = _e(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : h.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((f = (m = o.locale) == null ? void 0 : m.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, s = V(n, 0);
  s.setFullYear(r + 1, 0, a), s.setHours(0, 0, 0, 0);
  const l = we(s, t), c = V(n, 0);
  c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
  const d = we(c, t);
  return e.getTime() >= l.getTime() ? r + 1 : e.getTime() >= d.getTime() ? r : r - 1;
}
function Ti(n, t) {
  var l, c, d, u;
  const e = _e(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (l = t == null ? void 0 : t.locale) == null ? void 0 : l.options) == null ? void 0 : c.firstWeekContainsDate) ?? e.firstWeekContainsDate ?? ((u = (d = e.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = Lt(n, t), a = V(n, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), we(a, t);
}
function Xn(n, t) {
  const e = J(n), r = +we(e, t) - +Ti(e, t);
  return Math.round(r / Gn) + 1;
}
function Y(n, t) {
  const e = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(t, "0");
  return e + r;
}
const ge = {
  // Year
  y(n, t) {
    const e = n.getFullYear(), r = e > 0 ? e : 1 - e;
    return Y(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(n, t) {
    const e = n.getMonth();
    return t === "M" ? String(e + 1) : Y(e + 1, 2);
  },
  // Day of the month
  d(n, t) {
    return Y(n.getDate(), t.length);
  },
  // AM or PM
  a(n, t) {
    const e = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return e.toUpperCase();
      case "aaa":
        return e;
      case "aaaaa":
        return e[0];
      case "aaaa":
      default:
        return e === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, t) {
    return Y(n.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(n, t) {
    return Y(n.getHours(), t.length);
  },
  // Minute
  m(n, t) {
    return Y(n.getMinutes(), t.length);
  },
  // Second
  s(n, t) {
    return Y(n.getSeconds(), t.length);
  },
  // Fraction of second
  S(n, t) {
    const e = t.length, r = n.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, e - 3)
    );
    return Y(o, t.length);
  }
}, Oe = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, tn = {
  // Era
  G: function(n, t, e) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return e.era(r, { width: "abbreviated" });
      case "GGGGG":
        return e.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return e.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, t, e) {
    if (t === "yo") {
      const r = n.getFullYear(), o = r > 0 ? r : 1 - r;
      return e.ordinalNumber(o, { unit: "year" });
    }
    return ge.y(n, t);
  },
  // Local week-numbering year
  Y: function(n, t, e, r) {
    const o = Lt(n, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const s = a % 100;
      return Y(s, 2);
    }
    return t === "Yo" ? e.ordinalNumber(a, { unit: "year" }) : Y(a, t.length);
  },
  // ISO week-numbering year
  R: function(n, t) {
    const e = Vn(n);
    return Y(e, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, t) {
    const e = n.getFullYear();
    return Y(e, t.length);
  },
  // Quarter
  Q: function(n, t, e) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Y(r, 2);
      case "Qo":
        return e.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return e.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return e.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return e.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, t, e) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Y(r, 2);
      case "qo":
        return e.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return e.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return e.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return e.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, t, e) {
    const r = n.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return ge.M(n, t);
      case "Mo":
        return e.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return e.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return e.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return e.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, t, e) {
    const r = n.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Y(r + 1, 2);
      case "Lo":
        return e.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return e.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return e.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return e.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, t, e, r) {
    const o = Xn(n, r);
    return t === "wo" ? e.ordinalNumber(o, { unit: "week" }) : Y(o, t.length);
  },
  // ISO week of year
  I: function(n, t, e) {
    const r = Un(n);
    return t === "Io" ? e.ordinalNumber(r, { unit: "week" }) : Y(r, t.length);
  },
  // Day of the month
  d: function(n, t, e) {
    return t === "do" ? e.ordinalNumber(n.getDate(), { unit: "date" }) : ge.d(n, t);
  },
  // Day of year
  D: function(n, t, e) {
    const r = Ci(n);
    return t === "Do" ? e.ordinalNumber(r, { unit: "dayOfYear" }) : Y(r, t.length);
  },
  // Day of week
  E: function(n, t, e) {
    const r = n.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return e.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return e.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return e.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return e.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, t, e, r) {
    const o = n.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return Y(a, 2);
      case "eo":
        return e.ordinalNumber(a, { unit: "day" });
      case "eee":
        return e.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return e.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return e.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return e.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, t, e, r) {
    const o = n.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return Y(a, t.length);
      case "co":
        return e.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return e.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return e.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return e.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return e.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, t, e) {
    const r = n.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Y(o, t.length);
      case "io":
        return e.ordinalNumber(o, { unit: "day" });
      case "iii":
        return e.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return e.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return e.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return e.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, t, e) {
    const o = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return e.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return e.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, t, e) {
    const r = n.getHours();
    let o;
    switch (r === 12 ? o = Oe.noon : r === 0 ? o = Oe.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return e.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return e.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, t, e) {
    const r = n.getHours();
    let o;
    switch (r >= 17 ? o = Oe.evening : r >= 12 ? o = Oe.afternoon : r >= 4 ? o = Oe.morning : o = Oe.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return e.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return e.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return e.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, t, e) {
    if (t === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), e.ordinalNumber(r, { unit: "hour" });
    }
    return ge.h(n, t);
  },
  // Hour [0-23]
  H: function(n, t, e) {
    return t === "Ho" ? e.ordinalNumber(n.getHours(), { unit: "hour" }) : ge.H(n, t);
  },
  // Hour [0-11]
  K: function(n, t, e) {
    const r = n.getHours() % 12;
    return t === "Ko" ? e.ordinalNumber(r, { unit: "hour" }) : Y(r, t.length);
  },
  // Hour [1-24]
  k: function(n, t, e) {
    let r = n.getHours();
    return r === 0 && (r = 24), t === "ko" ? e.ordinalNumber(r, { unit: "hour" }) : Y(r, t.length);
  },
  // Minute
  m: function(n, t, e) {
    return t === "mo" ? e.ordinalNumber(n.getMinutes(), { unit: "minute" }) : ge.m(n, t);
  },
  // Second
  s: function(n, t, e) {
    return t === "so" ? e.ordinalNumber(n.getSeconds(), { unit: "second" }) : ge.s(n, t);
  },
  // Fraction of second
  S: function(n, t) {
    return ge.S(n, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, t, e) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return rn(r);
      case "XXXX":
      case "XX":
        return Te(r);
      case "XXXXX":
      case "XXX":
      default:
        return Te(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, t, e) {
    const r = n.getTimezoneOffset();
    switch (t) {
      case "x":
        return rn(r);
      case "xxxx":
      case "xx":
        return Te(r);
      case "xxxxx":
      case "xxx":
      default:
        return Te(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, t, e) {
    const r = n.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + nn(r, ":");
      case "OOOO":
      default:
        return "GMT" + Te(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, t, e) {
    const r = n.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + nn(r, ":");
      case "zzzz":
      default:
        return "GMT" + Te(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, t, e) {
    const r = Math.trunc(n.getTime() / 1e3);
    return Y(r, t.length);
  },
  // Milliseconds timestamp
  T: function(n, t, e) {
    const r = n.getTime();
    return Y(r, t.length);
  }
};
function nn(n, t = "") {
  const e = n > 0 ? "-" : "+", r = Math.abs(n), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? e + String(o) : e + String(o) + t + Y(a, 2);
}
function rn(n, t) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + Y(Math.abs(n) / 60, 2) : Te(n, t);
}
function Te(n, t = "") {
  const e = n > 0 ? "-" : "+", r = Math.abs(n), o = Y(Math.trunc(r / 60), 2), a = Y(r % 60, 2);
  return e + o + t + a;
}
const on = (n, t) => {
  switch (n) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Kn = (n, t) => {
  switch (n) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, ki = (n, t) => {
  const e = n.match(/(P+)(p+)?/) || [], r = e[1], o = e[2];
  if (!o)
    return on(n, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", on(r, t)).replace("{{time}}", Kn(o, t));
}, Tt = {
  p: Kn,
  P: ki
}, Pi = /^D+$/, Di = /^Y+$/, Mi = ["D", "DD", "YY", "YYYY"];
function Jn(n) {
  return Pi.test(n);
}
function Zn(n) {
  return Di.test(n);
}
function kt(n, t, e) {
  const r = Si(n, t, e);
  if (console.warn(r), Mi.includes(n)) throw new RangeError(r);
}
function Si(n, t, e) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${t}\`) for formatting ${r} to the input \`${e}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Oi = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ei = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ii = /^'([^]*?)'?$/, Ri = /''/g, Ni = /[a-zA-Z]/;
function an(n, t, e) {
  var u, h, m, f;
  const r = _e(), o = r.locale ?? Qn, a = r.firstWeekContainsDate ?? ((h = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, s = r.weekStartsOn ?? ((f = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : f.weekStartsOn) ?? 0, l = J(n);
  if (!jn(l))
    throw new RangeError("Invalid time value");
  let c = t.match(Ei).map((g) => {
    const w = g[0];
    if (w === "p" || w === "P") {
      const x = Tt[w];
      return x(g, o.formatLong);
    }
    return g;
  }).join("").match(Oi).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const w = g[0];
    if (w === "'")
      return { isToken: !1, value: Ai(g) };
    if (tn[w])
      return { isToken: !0, value: g };
    if (w.match(Ni))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + w + "`"
      );
    return { isToken: !1, value: g };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(l, c));
  const d = {
    firstWeekContainsDate: a,
    weekStartsOn: s,
    locale: o
  };
  return c.map((g) => {
    if (!g.isToken) return g.value;
    const w = g.value;
    (Zn(w) || Jn(w)) && kt(w, t, String(n));
    const x = tn[w[0]];
    return x(l, w, o.localize, d);
  }).join("");
}
function Ai(n) {
  const t = n.match(Ii);
  return t ? t[1].replace(Ri, "'") : n;
}
function Fi() {
  return Object.assign({}, _e());
}
function _i(n) {
  let e = J(n).getDay();
  return e === 0 && (e = 7), e;
}
function Li(n, t) {
  const e = t instanceof Date ? V(t, 0) : new t(0);
  return e.setFullYear(
    n.getFullYear(),
    n.getMonth(),
    n.getDate()
  ), e.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), e;
}
const Wi = 10;
class er {
  constructor() {
    P(this, "subPriority", 0);
  }
  validate(t, e) {
    return !0;
  }
}
class Yi extends er {
  constructor(t, e, r, o, a) {
    super(), this.value = t, this.validateValue = e, this.setValue = r, this.priority = o, a && (this.subPriority = a);
  }
  validate(t, e) {
    return this.validateValue(t, this.value, e);
  }
  set(t, e, r) {
    return this.setValue(t, e, this.value, r);
  }
}
class Hi extends er {
  constructor() {
    super(...arguments);
    P(this, "priority", Wi);
    P(this, "subPriority", -1);
  }
  set(e, r) {
    return r.timestampIsSet ? e : V(e, Li(e, Date));
  }
}
class L {
  run(t, e, r, o) {
    const a = this.parse(t, e, r, o);
    return a ? {
      setter: new Yi(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(t, e, r) {
    return !0;
  }
}
class zi extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 140);
    P(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(e, { width: "abbreviated" }) || o.era(e, { width: "narrow" });
      case "GGGGG":
        return o.era(e, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(e, { width: "wide" }) || o.era(e, { width: "abbreviated" }) || o.era(e, { width: "narrow" });
    }
  }
  set(e, r, o) {
    return r.era = o, e.setFullYear(o, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
const U = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, de = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function X(n, t) {
  return n && {
    value: t(n.value),
    rest: n.rest
  };
}
function $(n, t) {
  const e = t.match(n);
  return e ? {
    value: parseInt(e[0], 10),
    rest: t.slice(e[0].length)
  } : null;
}
function ue(n, t) {
  const e = t.match(n);
  if (!e)
    return null;
  if (e[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = e[1] === "+" ? 1 : -1, o = e[2] ? parseInt(e[2], 10) : 0, a = e[3] ? parseInt(e[3], 10) : 0, s = e[5] ? parseInt(e[5], 10) : 0;
  return {
    value: r * (o * La + a * _a + s * Wa),
    rest: t.slice(e[0].length)
  };
}
function tr(n) {
  return $(U.anyDigitsSigned, n);
}
function j(n, t) {
  switch (n) {
    case 1:
      return $(U.singleDigit, t);
    case 2:
      return $(U.twoDigits, t);
    case 3:
      return $(U.threeDigits, t);
    case 4:
      return $(U.fourDigits, t);
    default:
      return $(new RegExp("^\\d{1," + n + "}"), t);
  }
}
function et(n, t) {
  switch (n) {
    case 1:
      return $(U.singleDigitSigned, t);
    case 2:
      return $(U.twoDigitsSigned, t);
    case 3:
      return $(U.threeDigitsSigned, t);
    case 4:
      return $(U.fourDigitsSigned, t);
    default:
      return $(new RegExp("^-?\\d{1," + n + "}"), t);
  }
}
function Wt(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function nr(n, t) {
  const e = t > 0, r = e ? t : 1 - t;
  let o;
  if (r <= 50)
    o = n || 100;
  else {
    const a = r + 50, s = Math.trunc(a / 100) * 100, l = n >= a % 100;
    o = n + s - (l ? 100 : 0);
  }
  return e ? o : 1 - o;
}
function rr(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class Bi extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 130);
    P(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, r, o) {
    const a = (s) => ({
      year: s,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return X(j(4, e), a);
      case "yo":
        return X(
          o.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return X(j(r.length, e), a);
    }
  }
  validate(e, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(e, r, o) {
    const a = e.getFullYear();
    if (o.isTwoDigitYear) {
      const l = nr(
        o.year,
        a
      );
      return e.setFullYear(l, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const s = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class qi extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 130);
    P(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    const a = (s) => ({
      year: s,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return X(j(4, e), a);
      case "Yo":
        return X(
          o.ordinalNumber(e, {
            unit: "year"
          }),
          a
        );
      default:
        return X(j(r.length, e), a);
    }
  }
  validate(e, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(e, r, o, a) {
    const s = Lt(e, a);
    if (o.isTwoDigitYear) {
      const c = nr(
        o.year,
        s
      );
      return e.setFullYear(
        c,
        0,
        a.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), we(e, a);
    }
    const l = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return e.setFullYear(l, 0, a.firstWeekContainsDate), e.setHours(0, 0, 0, 0), we(e, a);
  }
}
class $i extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 130);
    P(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r) {
    return et(r === "R" ? 4 : r.length, e);
  }
  set(e, r, o) {
    const a = V(e, 0);
    return a.setFullYear(o, 0, 4), a.setHours(0, 0, 0, 0), Ae(a);
  }
}
class Gi extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 130);
    P(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(e, r) {
    return et(r === "u" ? 4 : r.length, e);
  }
  set(e, r, o) {
    return e.setFullYear(o, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Vi extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 120);
    P(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    switch (r) {
      case "Q":
      case "QQ":
        return j(r.length, e);
      case "Qo":
        return o.ordinalNumber(e, { unit: "quarter" });
      case "QQQ":
        return o.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 4;
  }
  set(e, r, o) {
    return e.setMonth((o - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class ji extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 120);
    P(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    switch (r) {
      case "q":
      case "qq":
        return j(r.length, e);
      case "qo":
        return o.ordinalNumber(e, { unit: "quarter" });
      case "qqq":
        return o.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 4;
  }
  set(e, r, o) {
    return e.setMonth((o - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Qi extends L {
  constructor() {
    super(...arguments);
    P(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    P(this, "priority", 110);
  }
  parse(e, r, o) {
    const a = (s) => s - 1;
    switch (r) {
      case "M":
        return X(
          $(U.month, e),
          a
        );
      case "MM":
        return X(j(2, e), a);
      case "Mo":
        return X(
          o.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      case "MMM":
        return o.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(e, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(e, { width: "wide", context: "formatting" }) || o.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, o) {
    return e.setMonth(o, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class Ui extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 110);
    P(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    const a = (s) => s - 1;
    switch (r) {
      case "L":
        return X(
          $(U.month, e),
          a
        );
      case "LL":
        return X(j(2, e), a);
      case "Lo":
        return X(
          o.ordinalNumber(e, {
            unit: "month"
          }),
          a
        );
      case "LLL":
        return o.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(e, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(e, { width: "wide", context: "standalone" }) || o.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, o) {
    return e.setMonth(o, 1), e.setHours(0, 0, 0, 0), e;
  }
}
function Xi(n, t, e) {
  const r = J(n), o = Xn(r, e) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class Ki extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 100);
    P(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    switch (r) {
      case "w":
        return $(U.week, e);
      case "wo":
        return o.ordinalNumber(e, { unit: "week" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 53;
  }
  set(e, r, o, a) {
    return we(Xi(e, o, a), a);
  }
}
function Ji(n, t) {
  const e = J(n), r = Un(e) - t;
  return e.setDate(e.getDate() - r * 7), e;
}
class Zi extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 100);
    P(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    switch (r) {
      case "I":
        return $(U.week, e);
      case "Io":
        return o.ordinalNumber(e, { unit: "week" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 53;
  }
  set(e, r, o) {
    return Ae(Ji(e, o));
  }
}
const es = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ts = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class ns extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 90);
    P(this, "subPriority", 1);
    P(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    switch (r) {
      case "d":
        return $(U.date, e);
      case "do":
        return o.ordinalNumber(e, { unit: "date" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    const o = e.getFullYear(), a = rr(o), s = e.getMonth();
    return a ? r >= 1 && r <= ts[s] : r >= 1 && r <= es[s];
  }
  set(e, r, o) {
    return e.setDate(o), e.setHours(0, 0, 0, 0), e;
  }
}
class rs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 90);
    P(this, "subpriority", 1);
    P(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return $(U.dayOfYear, e);
      case "Do":
        return o.ordinalNumber(e, { unit: "date" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    const o = e.getFullYear();
    return rr(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(e, r, o) {
    return e.setMonth(0, o), e.setHours(0, 0, 0, 0), e;
  }
}
function Yt(n, t, e) {
  var h, m, f, g;
  const r = _e(), o = (e == null ? void 0 : e.weekStartsOn) ?? ((m = (h = e == null ? void 0 : e.locale) == null ? void 0 : h.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((g = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : g.weekStartsOn) ?? 0, a = J(n), s = a.getDay(), c = (t % 7 + 7) % 7, d = 7 - o, u = t < 0 || t > 6 ? t - (s + d) % 7 : (c + d) % 7 - (s + d) % 7;
  return $n(a, u);
}
class os extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 90);
    P(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(e, { width: "wide", context: "formatting" }) || o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, o, a) {
    return e = Yt(e, o, a), e.setHours(0, 0, 0, 0), e;
  }
}
class as extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 90);
    P(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, o, a) {
    const s = (l) => {
      const c = Math.floor((l - 1) / 7) * 7;
      return (l + a.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "e":
      case "ee":
        return X(j(r.length, e), s);
      case "eo":
        return X(
          o.ordinalNumber(e, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(e, { width: "wide", context: "formatting" }) || o.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(e, { width: "short", context: "formatting" }) || o.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, o, a) {
    return e = Yt(e, o, a), e.setHours(0, 0, 0, 0), e;
  }
}
class is extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 90);
    P(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(e, r, o, a) {
    const s = (l) => {
      const c = Math.floor((l - 1) / 7) * 7;
      return (l + a.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "c":
      case "cc":
        return X(j(r.length, e), s);
      case "co":
        return X(
          o.ordinalNumber(e, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return o.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(e, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(e, { width: "wide", context: "standalone" }) || o.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(e, { width: "short", context: "standalone" }) || o.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 6;
  }
  set(e, r, o, a) {
    return e = Yt(e, o, a), e.setHours(0, 0, 0, 0), e;
  }
}
function ss(n, t) {
  const e = J(n), r = _i(e), o = t - r;
  return $n(e, o);
}
class cs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 90);
    P(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(e, r, o) {
    const a = (s) => s === 0 ? 7 : s;
    switch (r) {
      case "i":
      case "ii":
        return j(r.length, e);
      case "io":
        return o.ordinalNumber(e, { unit: "day" });
      case "iii":
        return X(
          o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiii":
        return X(
          o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiiii":
        return X(
          o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiii":
      default:
        return X(
          o.day(e, {
            width: "wide",
            context: "formatting"
          }) || o.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(e, {
            width: "short",
            context: "formatting"
          }) || o.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 7;
  }
  set(e, r, o) {
    return e = ss(e, o), e.setHours(0, 0, 0, 0), e;
  }
}
class ls extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 80);
    P(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, o) {
    return e.setHours(Wt(o), 0, 0, 0), e;
  }
}
class ds extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 80);
    P(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, o) {
    return e.setHours(Wt(o), 0, 0, 0), e;
  }
}
class us extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 80);
    P(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, r, o) {
    return e.setHours(Wt(o), 0, 0, 0), e;
  }
}
class hs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 70);
    P(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "h":
        return $(U.hour12h, e);
      case "ho":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 12;
  }
  set(e, r, o) {
    const a = e.getHours() >= 12;
    return a && o < 12 ? e.setHours(o + 12, 0, 0, 0) : !a && o === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(o, 0, 0, 0), e;
  }
}
class fs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 70);
    P(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "H":
        return $(U.hour23h, e);
      case "Ho":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 23;
  }
  set(e, r, o) {
    return e.setHours(o, 0, 0, 0), e;
  }
}
class ms extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 70);
    P(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "K":
        return $(U.hour11h, e);
      case "Ko":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 11;
  }
  set(e, r, o) {
    return e.getHours() >= 12 && o < 12 ? e.setHours(o + 12, 0, 0, 0) : e.setHours(o, 0, 0, 0), e;
  }
}
class gs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 70);
    P(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "k":
        return $(U.hour24h, e);
      case "ko":
        return o.ordinalNumber(e, { unit: "hour" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 1 && r <= 24;
  }
  set(e, r, o) {
    const a = o <= 24 ? o % 24 : o;
    return e.setHours(a, 0, 0, 0), e;
  }
}
class ps extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 60);
    P(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "m":
        return $(U.minute, e);
      case "mo":
        return o.ordinalNumber(e, { unit: "minute" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 59;
  }
  set(e, r, o) {
    return e.setMinutes(o, 0, 0), e;
  }
}
class ws extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 50);
    P(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r, o) {
    switch (r) {
      case "s":
        return $(U.second, e);
      case "so":
        return o.ordinalNumber(e, { unit: "second" });
      default:
        return j(r.length, e);
    }
  }
  validate(e, r) {
    return r >= 0 && r <= 59;
  }
  set(e, r, o) {
    return e.setSeconds(o, 0), e;
  }
}
class ys extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 30);
    P(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(e, r) {
    const o = (a) => Math.trunc(a * Math.pow(10, -r.length + 3));
    return X(j(r.length, e), o);
  }
  set(e, r, o) {
    return e.setMilliseconds(o), e;
  }
}
class bs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 10);
    P(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(e, r) {
    switch (r) {
      case "X":
        return ue(
          de.basicOptionalMinutes,
          e
        );
      case "XX":
        return ue(de.basic, e);
      case "XXXX":
        return ue(
          de.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return ue(
          de.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return ue(de.extended, e);
    }
  }
  set(e, r, o) {
    return r.timestampIsSet ? e : V(
      e,
      e.getTime() - Ze(e) - o
    );
  }
}
class xs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 10);
    P(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(e, r) {
    switch (r) {
      case "x":
        return ue(
          de.basicOptionalMinutes,
          e
        );
      case "xx":
        return ue(de.basic, e);
      case "xxxx":
        return ue(
          de.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return ue(
          de.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return ue(de.extended, e);
    }
  }
  set(e, r, o) {
    return r.timestampIsSet ? e : V(
      e,
      e.getTime() - Ze(e) - o
    );
  }
}
class vs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 40);
    P(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return tr(e);
  }
  set(e, r, o) {
    return [V(e, o * 1e3), { timestampIsSet: !0 }];
  }
}
class Cs extends L {
  constructor() {
    super(...arguments);
    P(this, "priority", 20);
    P(this, "incompatibleTokens", "*");
  }
  parse(e) {
    return tr(e);
  }
  set(e, r, o) {
    return [V(e, o), { timestampIsSet: !0 }];
  }
}
const Ts = {
  G: new zi(),
  y: new Bi(),
  Y: new qi(),
  R: new $i(),
  u: new Gi(),
  Q: new Vi(),
  q: new ji(),
  M: new Qi(),
  L: new Ui(),
  w: new Ki(),
  I: new Zi(),
  d: new ns(),
  D: new rs(),
  E: new os(),
  e: new as(),
  c: new is(),
  i: new cs(),
  a: new ls(),
  b: new ds(),
  B: new us(),
  h: new hs(),
  H: new fs(),
  K: new ms(),
  k: new gs(),
  m: new ps(),
  s: new ws(),
  S: new ys(),
  X: new bs(),
  x: new xs(),
  t: new vs(),
  T: new Cs()
}, ks = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ps = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ds = /^'([^]*?)'?$/, Ms = /''/g, Ss = /\S/, Os = /[a-zA-Z]/;
function Pt(n, t, e, r) {
  var w, x, v, T;
  const o = Fi(), a = o.locale ?? Qn, s = o.firstWeekContainsDate ?? ((x = (w = o.locale) == null ? void 0 : w.options) == null ? void 0 : x.firstWeekContainsDate) ?? 1, l = o.weekStartsOn ?? ((T = (v = o.locale) == null ? void 0 : v.options) == null ? void 0 : T.weekStartsOn) ?? 0;
  if (t === "")
    return n === "" ? J(e) : V(e, NaN);
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: l,
    locale: a
  }, d = [new Hi()], u = t.match(Ps).map((y) => {
    const p = y[0];
    if (p in Tt) {
      const b = Tt[p];
      return b(y, a.formatLong);
    }
    return y;
  }).join("").match(ks), h = [];
  for (let y of u) {
    Zn(y) && kt(y, t, n), Jn(y) && kt(y, t, n);
    const p = y[0], b = Ts[p];
    if (b) {
      const { incompatibleTokens: C } = b;
      if (Array.isArray(C)) {
        const F = h.find(
          (S) => C.includes(S.token) || S.token === p
        );
        if (F)
          throw new RangeError(
            `The format string mustn't contain \`${F.fullToken}\` and \`${y}\` at the same time`
          );
      } else if (b.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${y}\` and any other token at the same time`
        );
      h.push({ token: p, fullToken: y });
      const E = b.run(
        n,
        y,
        a.match,
        c
      );
      if (!E)
        return V(e, NaN);
      d.push(E.setter), n = E.rest;
    } else {
      if (p.match(Os))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + p + "`"
        );
      if (y === "''" ? y = "'" : p === "'" && (y = Es(y)), n.indexOf(y) === 0)
        n = n.slice(y.length);
      else
        return V(e, NaN);
    }
  }
  if (n.length > 0 && Ss.test(n))
    return V(e, NaN);
  const m = d.map((y) => y.priority).sort((y, p) => p - y).filter((y, p, b) => b.indexOf(y) === p).map(
    (y) => d.filter((p) => p.priority === y).sort((p, b) => b.subPriority - p.subPriority)
  ).map((y) => y[0]);
  let f = J(e);
  if (isNaN(f.getTime()))
    return V(e, NaN);
  const g = {};
  for (const y of m) {
    if (!y.validate(f, c))
      return V(e, NaN);
    const p = y.set(f, g, c);
    Array.isArray(p) ? (f = p[0], Object.assign(g, p[1])) : f = p;
  }
  return V(e, f);
}
function Es(n) {
  return n.match(Ds)[1].replace(Ms, "'");
}
function or(n, t, e) {
  return jn(Pt(n, t, /* @__PURE__ */ new Date()));
}
const sn = ({
  inputFormat: n = "yyyy-MM-dd",
  defaultValue: t,
  onChange: e,
  ...r
}) => {
  const [o] = Pe(), [a] = rt({ colorMode: o }), [s, l] = R(t);
  return /* @__PURE__ */ i(
    zr,
    {
      value: s,
      onChange: (d) => {
        l(d), e(d);
      },
      inputFormat: n,
      renderInput: ({ error: d, inputProps: u }) => {
        const h = !!(u != null && u.value) && d;
        return /* @__PURE__ */ i(
          xn,
          {
            ...u,
            error: h,
            placeholder: n,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            width: 150,
            startAdornment: /* @__PURE__ */ i(vn, { color: a.color.secondary, children: /* @__PURE__ */ i(so, {}) })
          }
        );
      },
      ...r
    }
  );
}, cn = ({
  onChange: n,
  ...t
}) => {
  const [e] = Pe(), [r] = rt({ colorMode: e });
  return /* @__PURE__ */ i(
    xn,
    {
      onChange: (a) => {
        const s = a.target.value;
        n(s);
      },
      width: 130,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      startAdornment: /* @__PURE__ */ i(vn, { color: r.color.secondary, children: /* @__PURE__ */ i(co, {}) }),
      ...t
    }
  );
}, Dt = "yyyy-MM-dd", Ye = "HH:mm:ss", ln = (n) => n instanceof Date ? !!n.getTime() : or(n, Dt), Ee = (n) => or(n, Ye), dn = (n, t) => {
  const [e, r, o] = t.split(":");
  return n.setHours(+e), n.setMinutes(+r), n.setSeconds(+o), n;
}, Is = (n) => {
  const { initialPickersValues: t, onClose: e, onApply: r } = n, o = se(() => /* @__PURE__ */ new Date(), []), a = o.toTimeString().split(" ")[0];
  let s = o, l = "00:00:00", c = o, d = "23:59:59";
  t != null && t.startDateTime && (s = new Date(t.startDateTime), l = an(s, Ye)), t != null && t.endDateTime && (c = new Date(t.endDateTime), d = an(c, Ye));
  const { t: u } = ce(), [h] = Pe(), [m] = rt({ colorMode: h }), [f, g] = R(s), [w, x] = R(l), [v, T] = R(c), [y, p] = R(d), b = () => {
    const O = +dn(new Date(f), w), _ = +dn(new Date(v), y);
    r({ startDateTime: O, endDateTime: _ });
  }, C = !(ln(f) && Ee(w) && ln(v) && Ee(y)), E = +Pt(w, Ye, f), F = +Pt(a, Ye, o), S = +f > +v || +f > +o || +v > +o, k = +E == +v || E > F;
  return /* @__PURE__ */ D(
    W,
    {
      backgroundColor: m.background.tertiary,
      position: "absolute",
      left: "0",
      top: 0,
      px: "3x",
      py: "3x",
      borderLeft: 1,
      borderColor: m.divider,
      children: [
        /* @__PURE__ */ D(q, { alignItems: "center", columnGap: "3x", mb: "6x", children: [
          /* @__PURE__ */ i(ne, { variant: "ghost", paddingLeft: "2x", paddingRight: "2x", onClick: e, children: /* @__PURE__ */ i(lo, { color: m.color.secondary }) }),
          /* @__PURE__ */ i(Z, { fontSize: "md", lineHeight: "md", children: u("Custom Period") })
        ] }),
        /* @__PURE__ */ D(yt, { templateColumns: "auto 1fr", alignItems: "center", rowGap: "3x", mb: "3x", children: [
          /* @__PURE__ */ i(Z, { minWidth: "16x", children: `${u("From")}:` }),
          /* @__PURE__ */ D(q, { columnGap: "2x", children: [
            /* @__PURE__ */ i(
              sn,
              {
                inputFormat: Dt,
                defaultValue: f,
                maxDate: v,
                onChange: (O) => {
                  g(O);
                }
              }
            ),
            /* @__PURE__ */ i(
              cn,
              {
                isInvalid: !Ee(w),
                defaultValue: w,
                error: !Ee(w) || k,
                onChange: (O) => {
                  x(O);
                }
              }
            )
          ] }),
          /* @__PURE__ */ i(Z, { minWidth: "16x", children: `${u("To")}:` }),
          /* @__PURE__ */ D(q, { columnGap: "2x", children: [
            /* @__PURE__ */ i(
              sn,
              {
                inputFormat: Dt,
                defaultValue: v,
                maxDate: o,
                onChange: (O) => {
                  T(O);
                }
              }
            ),
            /* @__PURE__ */ i(
              cn,
              {
                isInvalid: !Ee(y),
                value: y,
                error: !Ee(y) || k,
                onChange: (O) => {
                  p(O);
                }
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ i(q, { justifyContent: "flex-end", children: /* @__PURE__ */ D(yt, { templateColumns: "1fr 1fr", columnGap: "2x", children: [
          /* @__PURE__ */ i(
            ne,
            {
              variant: "primary",
              disabled: C || S || k,
              onClick: b,
              children: u("Apply")
            }
          ),
          /* @__PURE__ */ i(ne, { variant: "secondary", onClick: e, children: u("Cancel") })
        ] }) })
      ]
    }
  );
}, Fc = ({ title: n, width: t, onApply: e, onClose: r }) => {
  const { t: o } = ce(), [a, s] = R("all"), [l, c] = R(!0), [d, u] = R(!1), h = /* @__PURE__ */ new Date(), m = new Date(Date.now() - 7 * 24 * 60 * 60 * 1e3), [f, g] = R({ startDateTime: +m, endDateTime: +h }), w = ({
    startDateTime: T,
    endDateTime: y
  }) => {
    s("custom"), g({ startDateTime: T, endDateTime: y }), e({
      scanTimeFrom: Math.floor(T / 1e3),
      scanTimeTo: Math.floor(y / 1e3)
    }), u(!1), c(!1);
  }, x = (T, y) => {
    switch (T) {
      case "1d":
        h.setDate(h.getDate() - 1);
        break;
      case "7d":
        h.setDate(h.getDate() - 7);
        break;
      case "30d":
        h.setDate(h.getDate() - 30);
        break;
      case "90d":
        h.setDate(h.getDate() - 90);
        break;
      case "custom":
        y == null || y.preventDefault(), u(!d);
        return;
    }
    const p = T === "all" ? void 0 : Math.round(h.getTime() / 1e3), b = T !== "custom" ? void 0 : Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3);
    s(T), u(!1), c(!1), e({ scanTimeFrom: p, scanTimeTo: b });
  }, v = (T) => ({
    all: o("All"),
    "1d": o("Last 24 hours"),
    "7d": o("Last 7 days"),
    "30d": o("Last 30 days"),
    "90d": o("Last 90 days"),
    custom: o("Custom Period")
  })[T];
  return /* @__PURE__ */ i(ee, { children: /* @__PURE__ */ D(
    be,
    {
      defaultIsOpen: !1,
      isOpen: l,
      onClose: () => {
        u(!1), c(!1);
      },
      children: [
        /* @__PURE__ */ i(Be, { as: "div", children: /* @__PURE__ */ i(
          $e,
          {
            title: n,
            onClick: () => {
              c(!l);
            },
            onClear: () => {
              r == null || r();
            },
            children: /* @__PURE__ */ i(q, { columnGap: "1x", children: /* @__PURE__ */ i(Nt, { label: n, children: v(a) }) })
          }
        ) }),
        /* @__PURE__ */ i(xe, { width: t, children: d ? /* @__PURE__ */ i(
          Is,
          {
            initialPickersValues: f,
            onClose: () => {
              u(!1);
            },
            onApply: w
          }
        ) : /* @__PURE__ */ D(ee, { children: [
          ["all", "1d", "7d", "30d", "90d"].map((T) => /* @__PURE__ */ i(
            oe,
            {
              onClick: () => {
                x(T);
              },
              children: v(T)
            },
            T
          )),
          /* @__PURE__ */ D(
            oe,
            {
              onClick: (T) => {
                x("custom", T);
              },
              children: [
                v("custom"),
                /* @__PURE__ */ i(Ie, { width: "2x" }),
                /* @__PURE__ */ i(At, {})
              ]
            }
          )
        ] }) })
      ]
    }
  ) });
}, Rs = (n) => {
  const { label: t, onClose: e, value: r = "" } = n, [o, a] = R(!0), [s, l] = R("");
  return G(() => {
    r !== "" ? l(r) : a(!0);
  }, [r]), /* @__PURE__ */ i(
    $e,
    {
      title: t,
      onClick: () => {
        a(!o);
      },
      onClear: () => {
        e == null || e();
      },
      children: /* @__PURE__ */ i(q, { maxWidth: "200px", children: /* @__PURE__ */ i(Nt, { PopperProps: { usePortal: !0 }, label: s, children: s.trim() }) })
    }
  );
}, _c = (n) => {
  const { title: t, onApply: e, onClose: r, width: o, value: a = "" } = n, s = H(), [l, c] = R(!0), [d, u] = R(""), [h, m] = R(""), [f, g] = R(""), [w, x] = R(!1), { t: v } = ce(), T = h.length >= Gt, y = (C) => {
    h.trim() !== "" && u(C), m(C), x(C !== f);
  }, p = N(() => {
    h.trim() === "" ? r == null || r() : (e(h), g(h)), x(!1), c(!1);
  }, [h, r, e]), b = N(
    (C) => {
      ["Enter", "NumpadEnter"].includes(C.code) && (T || p());
    },
    [p, T]
  );
  return G(() => {
    l && setTimeout(() => {
      var C;
      (C = s.current) == null || C.focus();
    }, 100);
  }, [l]), G(() => {
    a !== "" ? (u(a), c(!1)) : c(!0);
  }, [a]), /* @__PURE__ */ D(
    be,
    {
      isOpen: l,
      onClose: () => {
        w || (f === "" && (r == null || r()), c(!1));
      },
      children: [
        /* @__PURE__ */ i(
          Be,
          {
            as: "div",
            onClick: () => {
              c(!l), m(f);
            },
            children: /* @__PURE__ */ i(
              Rs,
              {
                label: t,
                value: h,
                onClose: () => {
                  g(""), r == null || r();
                },
                onApply: e
              }
            )
          }
        ),
        /* @__PURE__ */ D(xe, { width: o, children: [
          /* @__PURE__ */ i(W, { padding: "2x", children: /* @__PURE__ */ i(
            it,
            {
              ref: s,
              error: T,
              variant: "outline",
              width: "100%",
              placeholder: t,
              value: d || h,
              maxLength: Gt,
              onChange: y,
              onKeyDown: b,
              debounceTime: 0
            }
          ) }),
          /* @__PURE__ */ i(W, { paddingBottom: "1x", paddingTop: "2x", paddingLeft: "2x", children: /* @__PURE__ */ i(ne, { variant: "primary", onClick: p, disabled: T, children: v("Apply") }) })
        ] })
      ]
    }
  );
}, ar = ({ filter: n, applySelectedFilters: t }) => /* @__PURE__ */ i(Et, { children: n.render({
  value: (n == null ? void 0 : n.key) ?? (n == null ? void 0 : n.value) ?? "",
  onChange: (e) => {
    const { key: r, value: o } = e ?? {}, a = o ?? e, s = r ?? null;
    t(
      (l) => l.map(
        (c) => c.id !== n.id ? c : {
          ...c,
          ...s && { key: s },
          value: a
        }
      )
    );
  },
  onClose: () => {
    t(
      (e) => e.filter((r) => r.id !== n.id)
    );
  }
}) }, n.id);
ar.displayName = "FilterRenderer";
const ir = (n) => {
  const { t } = ce();
  return /* @__PURE__ */ D(ne, { variant: "ghost", color: "blue:40", ...n, children: [
    /* @__PURE__ */ i(uo, {}),
    " ",
    /* @__PURE__ */ i(Z, { children: t("Clear") })
  ] });
};
ir.displayName = "FilterButton";
const Ns = ({
  selectedFilters: n,
  defaultFilters: t,
  setSelectedFilters: e,
  clearAllFilters: r,
  isLoading: o
}) => {
  const a = se(() => {
    const l = n.map(({ id: c }) => c);
    return t.filter((c) => !l.includes(c.id));
  }, [t, n]), s = N(() => {
    r && r(), e([]);
  }, [r, e]);
  return /* @__PURE__ */ D(ee, { children: [
    /* @__PURE__ */ D(be, { ...n.length > 0 && { marginRight: "2x" }, children: [
      /* @__PURE__ */ i(Be, { ...o && { pointerEvents: "none" }, children: ({ getMenuToggleProps: l }) => /* @__PURE__ */ i(W, { children: /* @__PURE__ */ i(
        ne,
        {
          ...l(),
          disabled: !a.length,
          variant: "secondary",
          textAlign: "left",
          height: "8x",
          display: "inline",
          ...n.length > 0 && {
            __after: {
              content: '""',
              position: "absolute",
              margin: "auto",
              height: "1px",
              width: "16px",
              top: "0",
              bottom: "0",
              right: "-17px",
              borderTop: "1px solid rgba(255, 255, 255, 0.28)"
            }
          },
          children: /* @__PURE__ */ D(q, { gap: "2x", children: [
            /* @__PURE__ */ i(ho, {}),
            /* @__PURE__ */ i(Z, { children: "Add filter" })
          ] })
        }
      ) }) }),
      /* @__PURE__ */ i(xe, { width: "max-content", PopperProps: { usePortal: !0 }, children: a.map((l) => /* @__PURE__ */ i(
        oe,
        {
          onClick: () => {
            e((c) => [...c, l]);
          },
          children: l.name
        },
        l.name
      )) })
    ] }),
    n.map(
      (l) => /* @__PURE__ */ i(W, { marginRight: "2x", children: /* @__PURE__ */ i(
        ar,
        {
          filter: l,
          applySelectedFilters: e
        },
        l.id
      ) }, l.id)
    ),
    /* @__PURE__ */ i(wt, { orientation: "vertical", height: "6x" }),
    n.length > 0 && /* @__PURE__ */ i(ir, { columnGap: "1x", onClick: s })
  ] });
};
Ns.displayName = "DynamicFilters";
const As = (n) => {
  const { in: t = !0, ...e } = n;
  return /* @__PURE__ */ i(It, { in: t, unmountOnExit: !0, children: /* @__PURE__ */ i(Br, { marginTop: "3x", ...e }) });
};
As.displayName = "Alert";
const Fs = ye((n, t) => {
  const { "data-track": e, ...r } = n, [o, a] = Array.isArray(e) ? e : [e];
  return /* @__PURE__ */ i(
    fn,
    {
      "data-track": o,
      "data-track-content": a,
      "data-testid": a ? `${o}-${a}` : o,
      ref: t,
      ...r
    }
  );
});
Fs.displayName = "TonicButtonBaseWrapper";
const _s = ye((n, t) => {
  const { "data-track": e, ...r } = n, [o, a] = Array.isArray(e) ? e : [e];
  return /* @__PURE__ */ i(
    ne,
    {
      "data-track": o,
      "data-track-content": a,
      "data-testid": a ? `${o}-${a}` : o,
      ref: t,
      ...r
    }
  );
});
_s.displayName = "TonicButtonWrapper";
const Ls = ye((n, t) => {
  const { "data-track": e, ...r } = n, [o, a] = Array.isArray(e) ? e : [e];
  return /* @__PURE__ */ i(
    Rt,
    {
      "data-track": o,
      "data-track-content": a,
      "data-testid": a ? `${o}-${a}` : o,
      ref: t,
      ...r
    }
  );
});
Ls.displayName = "TonicLinkButtonWrapper";
const Mt = window.location.hostname === "localhost", re = () => {
  var n;
  return Mt ? window.history : ((n = window.top) == null ? void 0 : n.history) ?? window.history;
}, Ws = (n, t) => {
  const e = [...Object.entries(n)].reduce((r, [o, a]) => t(o, a) ? { ...r, [o]: a } : r, {});
  return Object.keys(e).length === 0 ? void 0 : e;
}, Ys = (n, t) => {
  var e, r;
  try {
    const o = (() => {
      var s;
      const a = (s = window.parent) == null ? void 0 : s.location.hash.split("?");
      return a.length > 1 ? new URLSearchParams(a[1]) : void 0;
    })();
    if (o) {
      const a = [...o.entries()].reduce(
        (s, [l, c]) => ({ ...s, [l]: c }),
        {}
      );
      return t ? Ws(a, t) ?? n ?? {} : a;
    } else {
      if ((e = re().state) != null && e.appState)
        return (r = re().state) == null ? void 0 : r.appState;
      if (!re().state && n)
        return n;
    }
  } catch {
  }
  return {};
}, sr = St(void 0), Lc = () => {
  var a, s;
  const { _addHookListener: n, _removeHookListener: t, ...e } = Ot(sr), [r, o] = R(1);
  return ot(() => (n(o), () => t(o))), { ...e, state: ((s = (a = window.parent) == null ? void 0 : a.history.state) == null ? void 0 : s.appState) || {} };
}, Hs = (n) => {
  const { appUrl: t, defaultValue: e, validateQueryParams: r } = n, o = $t([]), a = Mt ? window.location.href : t;
  $t(() => {
    const m = Ys(e, r);
    re().replaceState({ ...re().state, appState: m }, "", a);
  });
  const s = N(
    (m) => o.push(m),
    [o]
  ), l = N(
    (m) => o.splice(o.indexOf(m), 1),
    [o]
  ), c = N(() => {
    o.forEach((m) => {
      m((f) => f + 1);
    });
  }, [o]), d = N(() => re().back(), []), u = N(
    (m) => {
      var g;
      let f;
      typeof m == "function" ? f = { ...m((g = re().state) == null ? void 0 : g.appState), canGoBack: !0 } : f = { ...m, canGoBack: !0 }, re().pushState({ ...re().state, appState: f }, "", a), c();
    },
    [c, a]
  ), h = N(
    (m) => {
      var g, w, x;
      let f;
      if (typeof m == "function")
        f = m((g = re().state) == null ? void 0 : g.appState);
      else {
        const v = (x = (w = re().state) == null ? void 0 : w.appState) == null ? void 0 : x.canGoBack;
        f = {
          ...m,
          ...v !== void 0 && { canGoBack: v }
        };
      }
      re().replaceState({ ...re().state, appState: f }, "", a), c();
    },
    [c, a]
  );
  return ot(() => {
    var f;
    const m = (g) => {
      var w, x, v, T;
      if (!Mt && (!((x = (w = g == null ? void 0 : g.state) == null ? void 0 : w.current) != null && x.includes(a == null ? void 0 : a.replace("#/", ""))) || // `current` is set by UIC's router whenever we navigate
      re().length > 0 && !((T = (v = window.top) == null ? void 0 : v.location.hash) != null && T.includes(a)))) {
        console.warn("Removed event listener"), window.removeEventListener("popstate", m);
        return;
      }
      c();
    };
    return (f = window.top) == null || f.addEventListener("popstate", m), () => {
      var g;
      (g = window.top) == null || g.removeEventListener("popstate", m);
    };
  }), /* @__PURE__ */ i(
    sr.Provider,
    {
      value: se(
        () => ({ pushState: u, replaceState: h, goBack: d, _addHookListener: s, _removeHookListener: l }),
        [u, h, d, s, l]
      ),
      ...n
    }
  );
};
Hs.displayName = "V1RouterProvider";
const zs = ({ footerNode: n, isClosable: t, variant: e }) => {
  const { onClose: r } = Ur(), { t: o } = ce();
  return n ? /* @__PURE__ */ i(qt, { children: n }) : t && e === "default" ? /* @__PURE__ */ i(qt, { children: /* @__PURE__ */ i(ne, { onClick: r, children: o("Close") }) }) : null;
}, Wc = (n) => {
  const {
    variant: t = "default",
    header: e,
    body: r,
    footer: o,
    onClose: a,
    backdrop: s = !0,
    isClosable: l = !0,
    size: c = "md",
    ...d
  } = n;
  return /* @__PURE__ */ D(
    qr,
    {
      autoFocus: !0,
      backdrop: s,
      isClosable: !1,
      placement: "right",
      closeOnEsc: !0,
      closeOnOutsideClick: !0,
      ensureFocus: !0,
      size: typeof c == "number" ? "auto" : c,
      onClose: a,
      ...d,
      children: [
        /* @__PURE__ */ i(
          po,
          {
            styles: wo`
          body {
            overflow: hidden;
          }
        `
          }
        ),
        s && /* @__PURE__ */ i($r, {}),
        /* @__PURE__ */ D(Gr, { ...typeof c == "number" && { width: c }, children: [
          /* @__PURE__ */ i(Vr, { color: "white:emphasis", children: e }),
          /* @__PURE__ */ i(jr, { children: r }),
          /* @__PURE__ */ i(zs, { variant: t, footerNode: o, isClosable: l }),
          l && /* @__PURE__ */ i(Qr, { "data-id": "drawer-close-button" })
        ] })
      ]
    }
  );
}, Bs = (n) => {
  const [t, e] = R(0), r = N(
    (o) => {
      var d;
      o.preventDefault();
      const a = t !== 0 ? t : ((d = n == null ? void 0 : n.current) == null ? void 0 : d.clientHeight) || 0, s = o.clientY, l = (u) => {
        const h = a + (u.clientY - s);
        e(h);
      }, c = () => {
        window.removeEventListener("mousemove", l), window.removeEventListener("mouseup", c);
      };
      window.addEventListener("mousemove", l), window.addEventListener("mouseup", c);
    },
    [t, n]
  );
  return { height: t, handleMouseDown: r };
}, qs = (n) => {
  const t = H(null), { top: e, bottom: r, isBottomFullScreen: o, isTopFullScreen: a } = n, { height: s, handleMouseDown: l } = Bs(t), c = 4, d = () => /* @__PURE__ */ i(W, { width: "3px", height: "3px", backgroundColor: "gray:60", borderRadius: "sm" });
  return /* @__PURE__ */ D(q, { flexDirection: "column", height: "100%", children: [
    /* @__PURE__ */ i(
      W,
      {
        ref: t,
        overflow: "hidden",
        style: {
          minHeight: o ? "0" : a ? "100%" : "20%",
          height: o ? "0%" : a ? "100%" : s === 0 ? "44%" : s
        },
        children: e
      }
    ),
    !o && /* @__PURE__ */ i(
      q,
      {
        height: "9px",
        borderTop: "2px solid",
        borderBottom: "2px solid",
        borderTopColor: "gray:60",
        borderBottomColor: "gray:60",
        cursor: "row-resize",
        onMouseDown: l,
        justifyContent: "center",
        alignItems: "center",
        style: {
          display: o ? void 0 : a ? "none" : void 0
        },
        children: Array.from({ length: c }, (u, h) => /* @__PURE__ */ i(d, {}, h))
      }
    ),
    /* @__PURE__ */ i(
      W,
      {
        flex: "1",
        style: {
          minHeight: o ? "100%" : a ? "0%" : "20%",
          height: o ? "100%" : a ? "0%" : void 0,
          display: o ? void 0 : a ? "none" : void 0
        },
        children: r
      }
    )
  ] });
};
qs.displayName = "SplitView";
const $s = (n) => {
  const { variant: t } = n, [e] = Hn();
  return /* @__PURE__ */ i(
    Xr,
    {
      position: "relative",
      __after: {
        ...t === "border-bottom" && {
          content: '""',
          borderBottom: 1,
          borderBottomColor: e.divider,
          position: "absolute",
          bottom: 0,
          width: "100%"
        },
        ...n.__after
      },
      ...n
    }
  );
};
$s.displayName = "TabList";
const cr = Fe((n) => {
  const { appName: t, ButtonComponent: e, timeout: r = 0 } = n, [o, a] = R(!1), [s, l] = R(!1), c = bo();
  Pa(r, () => a(!0));
  const d = N(() => {
    c.invalidateQueries({ queryKey: ["ass-api", "credit"] });
  }, [c]), u = N(
    (h) => {
      if (h.data === "RI_closeCreditSettings")
        l(!1);
      else {
        if (h.data === "RI_freeTrial_modalClose")
          return;
        (h.data === "RI_startTrial" || h.data.event === "RI_toggleASRM" || h.data.event === "RI_toggleAutoAllocateCredits" || h.data.event === "RI_updateCREMPricingPlan") && d();
      }
    },
    [d]
  );
  return G(() => (window.addEventListener("message", u), () => {
    window.removeEventListener("message", u);
  }), [u]), /* @__PURE__ */ D(ee, { children: [
    /* @__PURE__ */ i(
      e,
      {
        onClick: () => {
          l(!0), a(!0);
        }
      }
    ),
    /* @__PURE__ */ i(Kr, { children: o ? /* @__PURE__ */ i(
      "iframe",
      {
        title: "Credit Settings",
        src: `/ui/sase/shared/creditSettings?app=${t}`,
        style: {
          // Make the iframe fullscreen
          display: s ? "block" : "none",
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 1e3,
          width: "100%",
          height: "100%",
          colorScheme: "normal",
          // Hide iframe's default border
          border: "none"
        }
      }
    ) : null })
  ] });
});
cr.displayName = "CreditChecker";
const lr = () => {
  const n = H(null);
  return ot(() => {
    var t;
    (t = window.CREM) != null && t.renderCreditUsageButton && window.CREM.renderCreditUsageButton({
      app: "CMP",
      container: n.current
    });
  }), /* @__PURE__ */ i(W, { ref: n });
};
lr.displayName = "CreditsPopover";
const Gs = (n) => /* @__PURE__ */ i(ne, { variant: "secondary", paddingX: "2x", ...n, children: /* @__PURE__ */ i(fo, { size: "16px" }) }), Vs = Fe((n) => {
  const { appName: t, timeout: e } = n;
  return /* @__PURE__ */ D(q, { gap: "2x", children: [
    /* @__PURE__ */ i(lr, {}),
    /* @__PURE__ */ i(
      cr,
      {
        appName: t,
        ButtonComponent: Gs,
        timeout: e
      }
    )
  ] });
});
Vs.displayName = "CreditCheckingButtons";
const js = "Close", Qs = "All", Us = "Apply", Xs = "Cancel", Ks = "From", Js = "To", Zs = "None", ec = "Clear", Yc = {
  Close: js,
  "400 Bad Request": "400 Bad Request",
  "401 Unauthorized": "401 Unauthorized",
  "403 Forbidden": "403 Forbidden",
  "404 Not Found": "404 Not Found",
  "500 Internal Server Error": "500 Internal Server Error",
  "503 Service Unavailable": "503 Service Unavailable",
  "A temporary issue occurred. Support engineers are working to resolve the issue. Try again later.": "A temporary issue occurred. Support engineers are working to resolve the issue. Try again later.",
  "Temporary issue": "Temporary issue",
  "Clear All": "Clear All",
  "Select All": "Select All",
  All: Qs,
  "Last 24 hours": "Last 24 hours",
  "Last 7 days": "Last 7 days",
  "Custom Period": "Custom Period",
  Apply: Us,
  Cancel: Xs,
  "No Data to Display": "No Data to Display",
  "Loading ...": "Loading ...",
  From: Ks,
  To: Js,
  None: Zs,
  "Last 30 days": "Last 30 days",
  "Last 90 days": "Last 90 days",
  Clear: ec,
  "Total: {{count}}": "Total: {{count}}"
}, tc = "閉じる", nc = "すべて", rc = "適用", oc = "キャンセル", ac = "開始", ic = "終了", sc = "なし", cc = "クリア", Hc = {
  Close: tc,
  "400 Bad Request": "400 Bad Request",
  "401 Unauthorized": "401 権限がありません",
  "403 Forbidden": "403 禁止",
  "404 Not Found": "404 Not Found",
  "500 Internal Server Error": "500サーバの内部エラー",
  "503 Service Unavailable": "503サービス利用不可",
  "A temporary issue occurred. Support engineers are working to resolve the issue. Try again later.": "一時的な問題が発生しました。サポートエンジニアがこの問題の解決に取り組んでいます。後で再度実行してください。",
  "Temporary issue": "一時的な問題",
  "Clear All": "すべてクリア",
  "Select All": "すべて選択",
  All: nc,
  "Last 24 hours": "過去24時間",
  "Last 7 days": "過去7日間",
  "Custom Period": "カスタム期間",
  Apply: rc,
  Cancel: oc,
  "No Data to Display": "表示するデータがありません",
  "Loading ...": "ロードしています ...",
  From: ac,
  To: ic,
  None: sc,
  "Last 30 days": "過去30日間",
  "Last 90 days": "過去90日間",
  Clear: cc,
  "Total: {{count}}": "合計: {{count}}"
}, lc = "e2d0b822-a382-47b1-7fd0-4db539307d92", zc = () => {
  (function(n) {
    (function(t, e, r, o, a) {
      let s, l, c, d, u;
      for (a = t[o] = t[o] || {}, a._q = [], s = ["initialize", "identify", "updateOptions", "pageLoad"], l = 0, c = s.length; l < c; ++l)
        (function(h) {
          a[h] = a[h] || function() {
            a._q[h === s[0] ? "unshift" : "push"]([h].concat([].slice.call(arguments, 0)));
          };
        })(s[l]);
      d = e.createElement(r), d.async = !0, d.src = "https://content.analytics.trendmicro.com/agent/static/" + n + "/pendo.js", u = e.getElementsByTagName(r)[0], u.parentNode.insertBefore(d, u);
    })(window, document, "script", "pendo"), pendo.initialize({
      visitor: {
        id: localStorage.getItem("uic_userGUID"),
        role: localStorage.getItem("uic_roleGUID")
      },
      account: {
        id: localStorage.getItem("uic_companyGUID")
      }
    });
  })(lc);
}, Bc = {
  // ASD - cloud asset graph view feedback (https://app.eu.pendo.io/s/5715319363600384/guides/crspKjJ47U5pNggeGG3QGb2RDJM)
  REXFeedbackForm: "crspKjJ47U5pNggeGG3QGb2RDJM",
  SFLFeedbackForm: "i-mn6-HFVTTXOGZcKfcdoUx0FsM",
  // Survey - Compliance Management Feedback (https://app.eu.pendo.io/s/5715319363600384/guides/uI4rXvPdU5MD4pOTCeReelcdblQ)
  CREMFeedbackForm: "uI4rXvPdU5MD4pOTCeReelcdblQ"
}, tt = () => {
  var n;
  try {
    return !!(window.parent._TRACKABLE && ((n = window.pendo) != null && n.isReady()));
  } catch {
    return console.error("Error checking if pendo is ready"), !1;
  }
}, dc = (n) => {
  try {
    return tt() ? window.pendo.findGuideById(n) : void 0;
  } catch {
    console.error(`Error using pendo to find guide by id: ${n}`);
  }
}, qc = (n, t) => {
  try {
    if (!tt()) return;
    window.pendo.track(n, t);
  } catch {
    console.error(`Error using pendo to track event of type: ${n}`);
  }
}, $c = (n) => {
  if (typeof n > "u")
    return;
  let t;
  try {
    t = btoa(encodeURIComponent(JSON.stringify(n)));
  } catch {
  }
  return t;
}, uc = Fe((n) => {
  const { guideId: t, ...e } = n;
  return ka(1e3, !tt(), 3e4), tt() && dc(t) || Ue === "development" || Ue === "alpha" || Ue === "staging" ? /* @__PURE__ */ i(
    ne,
    {
      variant: "primary",
      gap: "2x",
      onClick: () => {
        var o;
        return (o = window.top) == null ? void 0 : o.pendo.showGuideById(t);
      },
      ...e
    }
  ) : null;
});
uc.displayName = "PendoGuideButton";
function hc(n, t) {
  if (Object.is(n, t))
    return !0;
  if (typeof n != "object" || n === null || typeof t != "object" || t === null)
    return !1;
  if (n instanceof Map && t instanceof Map) {
    if (n.size !== t.size)
      return !1;
    for (const [r, o] of n)
      if (!Object.is(o, t.get(r)))
        return !1;
    return !0;
  }
  if (n instanceof Set && t instanceof Set) {
    if (n.size !== t.size)
      return !1;
    for (const r of n)
      if (!t.has(r))
        return !1;
    return !0;
  }
  const e = Object.keys(n);
  if (e.length !== Object.keys(t).length)
    return !1;
  for (const r of e)
    if (!Object.prototype.hasOwnProperty.call(t, r) || !Object.is(n[r], t[r]))
      return !1;
  return !0;
}
const { useRef: fc } = Cr;
function mc(n) {
  const t = fc();
  return (e) => {
    const r = n(e);
    return hc(t.current, r) ? t.current : t.current = r;
  };
}
const dr = St(void 0), Gc = ({
  createStore: n,
  children: t
}) => {
  const e = H(null);
  return e.current || (e.current = n()), /* @__PURE__ */ i(dr.Provider, { value: e.current, children: t });
}, Vc = () => (...n) => {
  const t = Ot(dr);
  if (!t)
    throw new Error("Missing StoreProvider");
  return gc(t, ...n);
}, gc = (n, ...t) => {
  const e = t, r = e.length === 1 && typeof e[0] == "function";
  return n(
    mc(
      r ? e[0] : (o) => e.reduce((a, s) => ({ ...a, [s]: o[s] }), {})
    )
  );
}, ur = 200, jc = (n, t, e, r, o, a = ur, s = !0) => {
  const l = (g) => {
    for (; n.length < g; )
      n.push(t());
  };
  !s && n.length < a && l(a);
  const c = e.get("cursor") ?? void 0, d = parseFloat(e.get("limit") || "1");
  let u = n.filter(r), h;
  if (!c)
    h = 0;
  else {
    const g = u.findIndex((w) => o(w) === c);
    if (g === -1) return;
    h = g + 1;
  }
  let m = Math.min(a, h + d);
  u.length < m && (l(m), u = n.filter(r)), m = Math.min(u.length, h + d);
  const f = u.slice(h, m);
  return [
    // cursor
    m - h === d ? o(u[m - 1]) : void 0,
    // size of collection
    s ? a : u.length,
    // data
    f
  ];
}, Qc = (n, t, e, r, o = ur, a = !0) => {
  const s = (m) => {
    for (; n.length < m; )
      n.push(t());
  };
  !a && n.length < o && s(o);
  const l = typeof e.limit == "number" ? e.limit : parseFloat(e.limit || "1");
  let c = n.filter(r);
  const d = typeof e.offset == "number" ? e.offset ?? 0 : parseFloat(e.offset ?? "0");
  let u = Math.min(o, d + l);
  c.length < u && (s(u), c = n.filter(r)), u = Math.min(c.length, d + l);
  const h = c.slice(d, u);
  return [
    // size of collection
    a ? o : c.length,
    // data
    h
  ];
}, pc = (n) => n == null ? void 0 : n.isAxiosError, ft = Object.freeze([]), Uc = (n, t, e, r, o, a = !1) => {
  const s = H(0), l = o == null ? void 0 : o.onSuccess;
  a && o && delete o.onSuccess, !a && o && l && (o.onSuccess = (f) => {
    var g;
    return l(((g = f == null ? void 0 : f.pages) == null ? void 0 : g.flatMap((w) => e(w))) ?? ft);
  });
  const { data: c, hasPreviousPage: d, hasNextPage: u, ...h } = xo({
    queryKey: n,
    queryFn: t,
    getNextPageParam: (f, g, w) => {
      var v;
      const x = w + r;
      return (((v = f == null ? void 0 : f.data) == null ? void 0 : v.total) ?? 0) > x ? x : void 0;
    },
    initialPageParam: 0,
    ...o
  }), m = (h.isLoading || h.isFetching || u) && s.current <= 10;
  return G(() => {
    if (a) {
      if (s.current > 10) {
        console.warn("Aborting future fetch next page attempts");
        return;
      }
      !(h.isFetching || h.isFetchingNextPage) && u && (s.current++, h.fetchNextPage());
    }
  }, [h.isFetching, h.isFetchingNextPage, u, a]), G(() => {
    var f;
    a && (m || !h.isSuccess || l == null || l(((f = c == null ? void 0 : c.pages) == null ? void 0 : f.flatMap((g) => e(g))) ?? ft));
  }, [m, a, h.error, h.isSuccess]), {
    ...h,
    data: se(() => {
      var g, w, x, v;
      const f = ((g = c == null ? void 0 : c.pages) == null ? void 0 : g.flatMap((T) => e(T))) ?? ft;
      return {
        total: ((v = (x = (w = c == null ? void 0 : c.pages) == null ? void 0 : w[0]) == null ? void 0 : x.data) == null ? void 0 : v.total) ?? 0,
        // TODO: Most API return the total count. need to set from response
        items: f
      };
    }, [c == null ? void 0 : c.pages, e]),
    hasPreviousPage: d,
    hasNextPage: u,
    hasFetchedAllPages: !m
  };
}, Xc = (n, t) => (e) => {
  var o, a, s, l;
  let r;
  throw pc(e) ? e.response ? (r = {
    status: e.response.status,
    url: [(o = e.config) == null ? void 0 : o.method, (a = e.config) == null ? void 0 : a.url],
    data: e.response.data,
    headers: e.response.headers,
    errorType: t
  }, console.warn(`${n}: received 4xx/5xx response`, r)) : (r = {
    url: [(s = e.config) == null ? void 0 : s.method, (l = e.config) == null ? void 0 : l.url],
    data: { message: e.message },
    errorType: t
  }, console.warn(`${n}: no response received`, r)) : (r = { data: { message: (e == null ? void 0 : e.message) ?? "" }, errorType: t }, console.warn(`${n}: no request made`), console.warn(e)), r;
};
export {
  As as Alert,
  _s as Button,
  Fs as ButtonBase,
  vo as CURRENT_COMPANY,
  Ue as CURRENT_ENV,
  Ec as CaseManagement,
  Na as CheckListFilter,
  Aa as CheckListTreeFilter,
  Vs as CreditCheckingButtons,
  cr as CreditSettingsDrawer,
  lr as CreditsPopover,
  ur as DEFAULT_MAX_ITEMS,
  Fc as DateTimeFilter,
  Wc as Drawer,
  Ma as Dropdown,
  zn as DropdownButton,
  Sa as DropdownFilter,
  Ns as DynamicFilters,
  Mn as ErrorBoundary,
  ar as FilterRenderer,
  at as GeneralErrorOverlay,
  Re as I18n,
  _t as Li,
  Ls as LinkButton,
  En as Modal,
  Nc as ModalFooter,
  No as ModalsProvider,
  pa as MultilineOverflow,
  Ct as MultilineTruncateWithTooltip,
  Bn as Multiselect,
  Xo as NoData,
  Ea as Ol,
  Ia as P,
  uc as PendoGuideButton,
  Bc as PendoGuides,
  Oc as Regions,
  Da as SimpleTable,
  qs as SplitView,
  Gc as StoreProvider,
  $s as TabList,
  Ta as Table,
  Uo as TablePagination,
  _c as TextFilter,
  qe as TruncateWithTooltip,
  Ft as Ul,
  Hs as V1RouterProvider,
  Eo as arrayEquals,
  Ic as buildFlags,
  Xc as catchAPIErrorAndLog,
  On as comma,
  Vc as createStoreHook,
  Yc as enCommonUiStrings,
  $c as encodeDataTrackContent,
  pe as getAllTreeValues,
  Ac as getObjectId,
  jc as getPaginatedItemsByCursor,
  Qc as getPaginatedItemsByOffset,
  dc as getPendoGuide,
  pc as isAxiosError,
  tt as isPendoReady,
  Hc as jaCommonUiStrings,
  Ro as makeDeferred,
  qc as pendoTrack,
  zc as setupPendo,
  Uc as useFlatInfiniteQuery,
  ka as useInterval,
  Rc as useModals,
  Hn as useThemeStyle,
  Pa as useTimeout,
  Lc as useV1Router,
  Io as waitForTimeout
};
//# sourceMappingURL=index.js.map
